/**
 * Download Requests Status
 */
var DownloadRequestStatus;

(function (DownloadRequestStatus) {
  DownloadRequestStatus["SUCCESS"] = "SUCCESS";
  DownloadRequestStatus["PROCESSING"] = "PROCESSING";
  DownloadRequestStatus["ERROR"] = "ERROR";
})(DownloadRequestStatus || (DownloadRequestStatus = {}));

/**
 * Facet type
 */
var KpkApiFacetType;

(function (KpkApiFacetType) {
  KpkApiFacetType["CheckBox"] = "CHECK_BOX";
  KpkApiFacetType["Date"] = "DATE";
  KpkApiFacetType["Email"] = "EMAIL";
  KpkApiFacetType["FieldSet"] = "FIELD_SET";
  KpkApiFacetType["Geo"] = "GEO";
  KpkApiFacetType["HTML"] = "HTML";
  KpkApiFacetType["Microthesaurus"] = "MICROTHESAURUS";
  KpkApiFacetType["MultipleList"] = "MULTIPLE_LIST";
  KpkApiFacetType["Number"] = "NUMBER";
  KpkApiFacetType["PersonList"] = "PERSON_LIST";
  KpkApiFacetType["SimpleList"] = "SIMPLE_LIST";
  KpkApiFacetType["Text"] = "TEXT";
  KpkApiFacetType["TextArea"] = "TEXT_AREA";
  KpkApiFacetType["URL"] = "URL";
})(KpkApiFacetType || (KpkApiFacetType = {}));

var KpkApiClassificationValidationRequestStatus;

(function (KpkApiClassificationValidationRequestStatus) {
  KpkApiClassificationValidationRequestStatus["BeingProcessed"] = "BEING_PROCESSED";
  KpkApiClassificationValidationRequestStatus["Waiting"] = "WAITING";
})(KpkApiClassificationValidationRequestStatus || (KpkApiClassificationValidationRequestStatus = {}));

/**
 * Permission on metadata
 */
var KpkApiFieldPermission;

(function (KpkApiFieldPermission) {
  KpkApiFieldPermission["Read"] = "READ";
  KpkApiFieldPermission["Write"] = "WRITE";
})(KpkApiFieldPermission || (KpkApiFieldPermission = {}));

/**
 * Annotation
 */
var KpkApiMediaAnnotation;

(function (KpkApiMediaAnnotation) {
  KpkApiMediaAnnotation["Accepted"] = "ACCEPTED";
  KpkApiMediaAnnotation["Attention"] = "ATTENTION";
  KpkApiMediaAnnotation["Bookmark"] = "BOOKMARK";
  KpkApiMediaAnnotation["Flag"] = "FLAG";
  KpkApiMediaAnnotation["Green"] = "GREEN";
  KpkApiMediaAnnotation["InProgress"] = "IN_PROGRESS";
  KpkApiMediaAnnotation["Ko"] = "KO";
  KpkApiMediaAnnotation["None"] = "NONE";
  KpkApiMediaAnnotation["Ok"] = "OK";
  KpkApiMediaAnnotation["Orange"] = "ORANGE";
  KpkApiMediaAnnotation["Purple"] = "PURPLE";
  KpkApiMediaAnnotation["Red"] = "RED";
  KpkApiMediaAnnotation["Rejected"] = "REJECTED";
  KpkApiMediaAnnotation["ToRecycle"] = "TO_RECYCLE";
  KpkApiMediaAnnotation["ToRemove"] = "TO_REMOVE";
  KpkApiMediaAnnotation["Yellow"] = "YELLOW";
})(KpkApiMediaAnnotation || (KpkApiMediaAnnotation = {}));

var KpkApiMediaColorSpace;

(function (KpkApiMediaColorSpace) {
  KpkApiMediaColorSpace["Cmyk"] = "CMYK";
  KpkApiMediaColorSpace["SRGB"] = "sRGB";
})(KpkApiMediaColorSpace || (KpkApiMediaColorSpace = {}));
/**
 * Download level on media
 */


var KpkApiMediaDownloadLevel;

(function (KpkApiMediaDownloadLevel) {
  KpkApiMediaDownloadLevel["Bd"] = "BD";
  KpkApiMediaDownloadLevel["HD"] = "HD";
  KpkApiMediaDownloadLevel["None"] = "NONE";
})(KpkApiMediaDownloadLevel || (KpkApiMediaDownloadLevel = {}));

var KpkApiMediaDuplicateMediaStatus;

(function (KpkApiMediaDuplicateMediaStatus) {
  KpkApiMediaDuplicateMediaStatus["DuplicatesAcknowledged"] = "DUPLICATES_ACKNOWLEDGED";
  KpkApiMediaDuplicateMediaStatus["DuplicatesFound"] = "DUPLICATES_FOUND";
  KpkApiMediaDuplicateMediaStatus["NoDuplicates"] = "NO_DUPLICATES";
})(KpkApiMediaDuplicateMediaStatus || (KpkApiMediaDuplicateMediaStatus = {}));
/**
 * Permission on media
 */


var KpkApiMediaPermission;

(function (KpkApiMediaPermission) {
  KpkApiMediaPermission["Admin"] = "ADMIN";
  KpkApiMediaPermission["Delete"] = "DELETE";
  KpkApiMediaPermission["Publish"] = "PUBLISH";
  KpkApiMediaPermission["Read"] = "READ";
  KpkApiMediaPermission["Write"] = "WRITE";
})(KpkApiMediaPermission || (KpkApiMediaPermission = {}));
/**
 * Media Status
 */


var KpkApiMediaStatus;

(function (KpkApiMediaStatus) {
  KpkApiMediaStatus["Archived"] = "ARCHIVED";
  KpkApiMediaStatus["Basket"] = "BASKET";
  KpkApiMediaStatus["Draft"] = "DRAFT";
  KpkApiMediaStatus["Import"] = "IMPORT";
  KpkApiMediaStatus["Published"] = "PUBLISHED";
  KpkApiMediaStatus["Trash"] = "TRASH";
})(KpkApiMediaStatus || (KpkApiMediaStatus = {}));
/**
 * Media Orientation
 */


var KpkApiMediaOrientation;

(function (KpkApiMediaOrientation) {
  KpkApiMediaOrientation["Portrait"] = "PORTRAIT";
  KpkApiMediaOrientation["Landscape"] = "LANDSCAPE";
  KpkApiMediaOrientation["Square"] = "SQUARE";
})(KpkApiMediaOrientation || (KpkApiMediaOrientation = {}));

var KpkApiMediaThumbnailGenerationStatus;

(function (KpkApiMediaThumbnailGenerationStatus) {
  KpkApiMediaThumbnailGenerationStatus["Error"] = "ERROR";
  KpkApiMediaThumbnailGenerationStatus["Generated"] = "GENERATED";
  KpkApiMediaThumbnailGenerationStatus["NotGenerated"] = "NOT_GENERATED";
  KpkApiMediaThumbnailGenerationStatus["Refreshing"] = "REFRESHING";
})(KpkApiMediaThumbnailGenerationStatus || (KpkApiMediaThumbnailGenerationStatus = {}));

var KpkApiAdvancedSearchType;

(function (KpkApiAdvancedSearchType) {
  KpkApiAdvancedSearchType["Saved"] = "SAVED";
  KpkApiAdvancedSearchType["Temporary"] = "TEMPORARY";
})(KpkApiAdvancedSearchType || (KpkApiAdvancedSearchType = {}));

var KpkApiAdvancedSearchCriteriaAvailableModifier;

(function (KpkApiAdvancedSearchCriteriaAvailableModifier) {
  KpkApiAdvancedSearchCriteriaAvailableModifier["BeginsWith"] = "BEGINS_WITH";
  KpkApiAdvancedSearchCriteriaAvailableModifier["ContainsAll"] = "CONTAINS_ALL";
  KpkApiAdvancedSearchCriteriaAvailableModifier["ContainsNone"] = "CONTAINS_NONE";
  KpkApiAdvancedSearchCriteriaAvailableModifier["ContainsOne"] = "CONTAINS_ONE";
  KpkApiAdvancedSearchCriteriaAvailableModifier["DateCurrentMonth"] = "DATE_CURRENT_MONTH";
  KpkApiAdvancedSearchCriteriaAvailableModifier["DateFromToUpcomingDays"] = "DATE_FROM_TO_UPCOMING_DAYS";
  KpkApiAdvancedSearchCriteriaAvailableModifier["DateFromToUpcomingDaysOrEmpty"] = "DATE_FROM_TO_UPCOMING_DAYS_OR_EMPTY";
  KpkApiAdvancedSearchCriteriaAvailableModifier["DateLast30Days"] = "DATE_LAST_30_DAYS";
  KpkApiAdvancedSearchCriteriaAvailableModifier["DateLast7Days"] = "DATE_LAST_7_DAYS";
  KpkApiAdvancedSearchCriteriaAvailableModifier["DateLastMonth"] = "DATE_LAST_MONTH";
  KpkApiAdvancedSearchCriteriaAvailableModifier["DateToday"] = "DATE_TODAY";
  KpkApiAdvancedSearchCriteriaAvailableModifier["DateYesterday"] = "DATE_YESTERDAY";
  KpkApiAdvancedSearchCriteriaAvailableModifier["Empty"] = "EMPTY";
  KpkApiAdvancedSearchCriteriaAvailableModifier["EndsWith"] = "ENDS_WITH";
  KpkApiAdvancedSearchCriteriaAvailableModifier["Equals"] = "EQUALS";
  KpkApiAdvancedSearchCriteriaAvailableModifier["EqualsNoValues"] = "EQUALS_NO_VALUES";
  KpkApiAdvancedSearchCriteriaAvailableModifier["EqualsOne"] = "EQUALS_ONE";
  KpkApiAdvancedSearchCriteriaAvailableModifier["FromTo"] = "FROM_TO";
  KpkApiAdvancedSearchCriteriaAvailableModifier["GroupContainsNone"] = "GROUP_CONTAINS_NONE";
  KpkApiAdvancedSearchCriteriaAvailableModifier["GroupContainsOne"] = "GROUP_CONTAINS_ONE";
  KpkApiAdvancedSearchCriteriaAvailableModifier["NotEmpty"] = "NOT_EMPTY";
})(KpkApiAdvancedSearchCriteriaAvailableModifier || (KpkApiAdvancedSearchCriteriaAvailableModifier = {}));
/**
 * Type of field. MEDIAFIELD stands for property of the media resource and METAFIELD for a
 * configured field in the media form
 */


var KpkApiAdvancedSearchCriteriaFieldType;

(function (KpkApiAdvancedSearchCriteriaFieldType) {
  KpkApiAdvancedSearchCriteriaFieldType["Mediafield"] = "MEDIAFIELD";
  KpkApiAdvancedSearchCriteriaFieldType["Metafield"] = "METAFIELD";
})(KpkApiAdvancedSearchCriteriaFieldType || (KpkApiAdvancedSearchCriteriaFieldType = {}));
/**
 * Advanced search filter type
 */


var KpkApiAdvancedSearchCriteriaType;

(function (KpkApiAdvancedSearchCriteriaType) {
  KpkApiAdvancedSearchCriteriaType["Associationsfield"] = "ASSOCIATIONSFIELD";
  KpkApiAdvancedSearchCriteriaType["Checkboxfield"] = "CHECKBOXFIELD";
  KpkApiAdvancedSearchCriteriaType["Datefield"] = "DATEFIELD";
  KpkApiAdvancedSearchCriteriaType["Datetimefield"] = "DATETIMEFIELD";
  KpkApiAdvancedSearchCriteriaType["Emailfield"] = "EMAILFIELD";
  KpkApiAdvancedSearchCriteriaType["Extensionfield"] = "EXTENSIONFIELD";
  KpkApiAdvancedSearchCriteriaType["Filesizefield"] = "FILESIZEFIELD";
  KpkApiAdvancedSearchCriteriaType["Folderfield"] = "FOLDERFIELD";
  KpkApiAdvancedSearchCriteriaType["Geofield"] = "GEOFIELD";
  KpkApiAdvancedSearchCriteriaType["Htmlfield"] = "HTMLFIELD";
  KpkApiAdvancedSearchCriteriaType["Listfield"] = "LISTFIELD";
  KpkApiAdvancedSearchCriteriaType["Metamodelfield"] = "METAMODELFIELD";
  KpkApiAdvancedSearchCriteriaType["Metamodeltypefield"] = "METAMODELTYPEFIELD";
  KpkApiAdvancedSearchCriteriaType["Multiplelistfield"] = "MULTIPLELISTFIELD";
  KpkApiAdvancedSearchCriteriaType["Numberfield"] = "NUMBERFIELD";
  KpkApiAdvancedSearchCriteriaType["Personsfield"] = "PERSONSFIELD";
  KpkApiAdvancedSearchCriteriaType["Socialnetworksfield"] = "SOCIALNETWORKSFIELD";
  KpkApiAdvancedSearchCriteriaType["Statusfield"] = "STATUSFIELD";
  KpkApiAdvancedSearchCriteriaType["Tagsfield"] = "TAGSFIELD";
  KpkApiAdvancedSearchCriteriaType["Textarea"] = "TEXTAREA";
  KpkApiAdvancedSearchCriteriaType["Textfield"] = "TEXTFIELD";
  KpkApiAdvancedSearchCriteriaType["Thesaurusfield"] = "THESAURUSFIELD";
  KpkApiAdvancedSearchCriteriaType["Unknonwfield"] = "UNKNONWFIELD";
  KpkApiAdvancedSearchCriteriaType["Urlfield"] = "URLFIELD";
  KpkApiAdvancedSearchCriteriaType["Usersfield"] = "USERSFIELD";
  KpkApiAdvancedSearchCriteriaType["Durationfield"] = "DURATIONFIELD";
})(KpkApiAdvancedSearchCriteriaType || (KpkApiAdvancedSearchCriteriaType = {}));

/**
 * Type of field. MEDIAFIELD stands for property of the media resource and METAFIELD for a
 * configured field in the media form
 */
var KpkApiAdvancedSearchFilterFieldType;

(function (KpkApiAdvancedSearchFilterFieldType) {
  KpkApiAdvancedSearchFilterFieldType["Mediafield"] = "MEDIAFIELD";
  KpkApiAdvancedSearchFilterFieldType["Metafield"] = "METAFIELD";
})(KpkApiAdvancedSearchFilterFieldType || (KpkApiAdvancedSearchFilterFieldType = {}));
/**
 * Filter modifier
 */


var KpkApiAdvancedSearchFilterModifier;

(function (KpkApiAdvancedSearchFilterModifier) {
  KpkApiAdvancedSearchFilterModifier["BeginsWith"] = "BEGINS_WITH";
  KpkApiAdvancedSearchFilterModifier["ContainsAll"] = "CONTAINS_ALL";
  KpkApiAdvancedSearchFilterModifier["ContainsNone"] = "CONTAINS_NONE";
  KpkApiAdvancedSearchFilterModifier["ContainsOne"] = "CONTAINS_ONE";
  KpkApiAdvancedSearchFilterModifier["DateCurrentMonth"] = "DATE_CURRENT_MONTH";
  KpkApiAdvancedSearchFilterModifier["DateFromToUpcomingDays"] = "DATE_FROM_TO_UPCOMING_DAYS";
  KpkApiAdvancedSearchFilterModifier["DateFromToUpcomingDaysOrEmpty"] = "DATE_FROM_TO_UPCOMING_DAYS_OR_EMPTY";
  KpkApiAdvancedSearchFilterModifier["DateLast30Days"] = "DATE_LAST_30_DAYS";
  KpkApiAdvancedSearchFilterModifier["DateLast7Days"] = "DATE_LAST_7_DAYS";
  KpkApiAdvancedSearchFilterModifier["DateLastMonth"] = "DATE_LAST_MONTH";
  KpkApiAdvancedSearchFilterModifier["DateToday"] = "DATE_TODAY";
  KpkApiAdvancedSearchFilterModifier["DateYesterday"] = "DATE_YESTERDAY";
  KpkApiAdvancedSearchFilterModifier["Empty"] = "EMPTY";
  KpkApiAdvancedSearchFilterModifier["EndsWith"] = "ENDS_WITH";
  KpkApiAdvancedSearchFilterModifier["Equals"] = "EQUALS";
  KpkApiAdvancedSearchFilterModifier["EqualsNoValues"] = "EQUALS_NO_VALUES";
  KpkApiAdvancedSearchFilterModifier["EqualsOne"] = "EQUALS_ONE";
  KpkApiAdvancedSearchFilterModifier["FromTo"] = "FROM_TO";
  KpkApiAdvancedSearchFilterModifier["GroupContainsNone"] = "GROUP_CONTAINS_NONE";
  KpkApiAdvancedSearchFilterModifier["GroupContainsOne"] = "GROUP_CONTAINS_ONE";
  KpkApiAdvancedSearchFilterModifier["NotEmpty"] = "NOT_EMPTY";
})(KpkApiAdvancedSearchFilterModifier || (KpkApiAdvancedSearchFilterModifier = {}));
/**
 * Advanced search filter type
 */


var KpkApiAdvancedSearchFilterType;

(function (KpkApiAdvancedSearchFilterType) {
  KpkApiAdvancedSearchFilterType["Associationsfield"] = "ASSOCIATIONSFIELD";
  KpkApiAdvancedSearchFilterType["Checkboxfield"] = "CHECKBOXFIELD";
  KpkApiAdvancedSearchFilterType["Datefield"] = "DATEFIELD";
  KpkApiAdvancedSearchFilterType["Datetimefield"] = "DATETIMEFIELD";
  KpkApiAdvancedSearchFilterType["Emailfield"] = "EMAILFIELD";
  KpkApiAdvancedSearchFilterType["Extensionfield"] = "EXTENSIONFIELD";
  KpkApiAdvancedSearchFilterType["Filesizefield"] = "FILESIZEFIELD";
  KpkApiAdvancedSearchFilterType["Folderfield"] = "FOLDERFIELD";
  KpkApiAdvancedSearchFilterType["Geofield"] = "GEOFIELD";
  KpkApiAdvancedSearchFilterType["Htmlfield"] = "HTMLFIELD";
  KpkApiAdvancedSearchFilterType["Listfield"] = "LISTFIELD";
  KpkApiAdvancedSearchFilterType["Metamodelfield"] = "METAMODELFIELD";
  KpkApiAdvancedSearchFilterType["Metamodeltypefield"] = "METAMODELTYPEFIELD";
  KpkApiAdvancedSearchFilterType["Multiplelistfield"] = "MULTIPLELISTFIELD";
  KpkApiAdvancedSearchFilterType["Numberfield"] = "NUMBERFIELD";
  KpkApiAdvancedSearchFilterType["Personsfield"] = "PERSONSFIELD";
  KpkApiAdvancedSearchFilterType["Socialnetworksfield"] = "SOCIALNETWORKSFIELD";
  KpkApiAdvancedSearchFilterType["Statusfield"] = "STATUSFIELD";
  KpkApiAdvancedSearchFilterType["Tagsfield"] = "TAGSFIELD";
  KpkApiAdvancedSearchFilterType["Textarea"] = "TEXTAREA";
  KpkApiAdvancedSearchFilterType["Textfield"] = "TEXTFIELD";
  KpkApiAdvancedSearchFilterType["Thesaurusfield"] = "THESAURUSFIELD";
  KpkApiAdvancedSearchFilterType["Unknonwfield"] = "UNKNONWFIELD";
  KpkApiAdvancedSearchFilterType["Urlfield"] = "URLFIELD";
  KpkApiAdvancedSearchFilterType["Usersfield"] = "USERSFIELD";
})(KpkApiAdvancedSearchFilterType || (KpkApiAdvancedSearchFilterType = {}));

var KpkApiSheetFieldType;

(function (KpkApiSheetFieldType) {
  KpkApiSheetFieldType["CheckBox"] = "CHECK_BOX";
  KpkApiSheetFieldType["Date"] = "DATE";
  KpkApiSheetFieldType["Datetime"] = "DATETIME";
  KpkApiSheetFieldType["Email"] = "EMAIL";
  KpkApiSheetFieldType["FieldSet"] = "FIELD_SET";
  KpkApiSheetFieldType["Geo"] = "GEO";
  KpkApiSheetFieldType["HTML"] = "HTML";
  KpkApiSheetFieldType["MultipleList"] = "MULTIPLE_LIST";
  KpkApiSheetFieldType["Number"] = "NUMBER";
  KpkApiSheetFieldType["PersonList"] = "PERSON_LIST";
  KpkApiSheetFieldType["SimpleList"] = "SIMPLE_LIST";
  KpkApiSheetFieldType["Text"] = "TEXT";
  KpkApiSheetFieldType["TextArea"] = "TEXT_AREA";
  KpkApiSheetFieldType["Thesaurus"] = "THESAURUS";
  KpkApiSheetFieldType["URL"] = "URL";
})(KpkApiSheetFieldType || (KpkApiSheetFieldType = {}));

var KpkApiFormType;

(function (KpkApiFormType) {
  KpkApiFormType["Document"] = "DOCUMENT";
  KpkApiFormType["Other"] = "OTHER";
  KpkApiFormType["Picture"] = "PICTURE";
  KpkApiFormType["Sound"] = "SOUND";
  KpkApiFormType["Video"] = "VIDEO";
  KpkApiFormType["RICH_MEDIA"] = "RICH_MEDIA";
})(KpkApiFormType || (KpkApiFormType = {}));

var KpkApiFormFieldType;

(function (KpkApiFormFieldType) {
  KpkApiFormFieldType["CheckBox"] = "CHECK_BOX";
  KpkApiFormFieldType["Date"] = "DATE";
  KpkApiFormFieldType["Datetime"] = "DATETIME";
  KpkApiFormFieldType["Email"] = "EMAIL";
  KpkApiFormFieldType["FieldSet"] = "FIELD_SET";
  KpkApiFormFieldType["Geo"] = "GEO";
  KpkApiFormFieldType["HTML"] = "HTML";
  KpkApiFormFieldType["MultipleList"] = "MULTIPLE_LIST";
  KpkApiFormFieldType["Number"] = "NUMBER";
  KpkApiFormFieldType["PersonList"] = "PERSON_LIST";
  KpkApiFormFieldType["SimpleList"] = "SIMPLE_LIST";
  KpkApiFormFieldType["Text"] = "TEXT";
  KpkApiFormFieldType["TextArea"] = "TEXT_AREA";
  KpkApiFormFieldType["Thesaurus"] = "THESAURUS";
  KpkApiFormFieldType["URL"] = "URL";
})(KpkApiFormFieldType || (KpkApiFormFieldType = {}));

/**
 * Permission on user
 */
var KpkApiUserPermission;

(function (KpkApiUserPermission) {
  KpkApiUserPermission["Delete"] = "DELETE";
  KpkApiUserPermission["Read"] = "READ";
  KpkApiUserPermission["Write"] = "WRITE";
})(KpkApiUserPermission || (KpkApiUserPermission = {}));

/**
 * Permission of the current user on the folder
 */
var KpkApiFolderNodePermission;

(function (KpkApiFolderNodePermission) {
  KpkApiFolderNodePermission["Admin"] = "ADMIN";
  KpkApiFolderNodePermission["Delete"] = "DELETE";
  KpkApiFolderNodePermission["HD"] = "HD";
  KpkApiFolderNodePermission["Ld"] = "LD";
  KpkApiFolderNodePermission["NotGranted"] = "NOT_GRANTED";
  KpkApiFolderNodePermission["Publish"] = "PUBLISH";
  KpkApiFolderNodePermission["Read"] = "READ";
  KpkApiFolderNodePermission["Write"] = "WRITE";
})(KpkApiFolderNodePermission || (KpkApiFolderNodePermission = {}));

var KpkApiSearchFolderSort;

(function (KpkApiSearchFolderSort) {
  KpkApiSearchFolderSort["Title"] = "title";
  KpkApiSearchFolderSort["Id"] = "id";
  KpkApiSearchFolderSort["Sequence"] = "sequence";
})(KpkApiSearchFolderSort || (KpkApiSearchFolderSort = {}));

/**
 * Type of a script
 */
var KpkApiScriptType;

(function (KpkApiScriptType) {
  KpkApiScriptType["MediaSelection"] = "MEDIA_SELECTION";
  KpkApiScriptType["Standalone"] = "STANDALONE";
  KpkApiScriptType["Flexible"] = "FLEXIBLE";
})(KpkApiScriptType || (KpkApiScriptType = {}));

/**
 * Status of a script execution
 */
var KpkApiScriptRunStatus;

(function (KpkApiScriptRunStatus) {
  KpkApiScriptRunStatus["Started"] = "STARTED";
  KpkApiScriptRunStatus["EndedOK"] = "ENDED_OK";
  KpkApiScriptRunStatus["EndedKO"] = "ENDED_KO";
})(KpkApiScriptRunStatus || (KpkApiScriptRunStatus = {}));

/**
 * Permission on basket
 */
var KpkApiBasketPermission;

(function (KpkApiBasketPermission) {
  KpkApiBasketPermission["Admin"] = "ADMIN";
  KpkApiBasketPermission["Read"] = "READ";
  KpkApiBasketPermission["Write"] = "WRITE";
})(KpkApiBasketPermission || (KpkApiBasketPermission = {}));
/**
 * Basket active status
 */


var KpkApiBasketStatus;

(function (KpkApiBasketStatus) {
  KpkApiBasketStatus["Activated"] = "ACTIVATED";
  KpkApiBasketStatus["Deactivated"] = "DEACTIVATED";
})(KpkApiBasketStatus || (KpkApiBasketStatus = {}));
/**
 * Defines share type
 */


var KpkApiBasketType;

(function (KpkApiBasketType) {
  KpkApiBasketType["Personal"] = "PERSONAL";
  KpkApiBasketType["Shared"] = "SHARED";
})(KpkApiBasketType || (KpkApiBasketType = {}));

var KpkApiSelectionAvailableExportGroupBy;

(function (KpkApiSelectionAvailableExportGroupBy) {
  KpkApiSelectionAvailableExportGroupBy["MediaType"] = "mediaType";
})(KpkApiSelectionAvailableExportGroupBy || (KpkApiSelectionAvailableExportGroupBy = {}));

var Definition;

(function (Definition) {
  Definition["NONE"] = "NONE";
  Definition["BD"] = "BD";
  Definition["HD"] = "HD";
})(Definition || (Definition = {}));

var KpkApiAssignedGroupStatus;

(function (KpkApiAssignedGroupStatus) {
  KpkApiAssignedGroupStatus["Deactivated"] = "DEACTIVATED";
  KpkApiAssignedGroupStatus["Deleted"] = "DELETED";
  KpkApiAssignedGroupStatus["Locked"] = "LOCKED";
  KpkApiAssignedGroupStatus["ToBeValidated"] = "TO_BE_VALIDATED";
  KpkApiAssignedGroupStatus["Valid"] = "VALID";
})(KpkApiAssignedGroupStatus || (KpkApiAssignedGroupStatus = {}));

var KpkApiVideoConfigurationThemeValue;

(function (KpkApiVideoConfigurationThemeValue) {
  KpkApiVideoConfigurationThemeValue["Default"] = "default";
  KpkApiVideoConfigurationThemeValue["Fantasy"] = "fantasy";
})(KpkApiVideoConfigurationThemeValue || (KpkApiVideoConfigurationThemeValue = {}));

var KpkApiVideoConfigurationTrackKind;

(function (KpkApiVideoConfigurationTrackKind) {
  KpkApiVideoConfigurationTrackKind["Chapters"] = "chapters";
  KpkApiVideoConfigurationTrackKind["Subtitles"] = "subtitles";
})(KpkApiVideoConfigurationTrackKind || (KpkApiVideoConfigurationTrackKind = {}));

/**
 * Type of user interface
 */
var KpkApiUiType;

(function (KpkApiUiType) {
  KpkApiUiType["ApplicationTiers"] = "APPLICATION_TIERS";
  KpkApiUiType["Backoffice"] = "BACKOFFICE";
  KpkApiUiType["Frontoffice"] = "FRONTOFFICE";
  KpkApiUiType["Refront"] = "REFRONT";
})(KpkApiUiType || (KpkApiUiType = {}));

/**
 * Share export definition
 */
var KpkApiPublicShareExportDefinition;

(function (KpkApiPublicShareExportDefinition) {
  KpkApiPublicShareExportDefinition["Bd"] = "BD";
  KpkApiPublicShareExportDefinition["HD"] = "HD";
  KpkApiPublicShareExportDefinition["None"] = "NONE";
})(KpkApiPublicShareExportDefinition || (KpkApiPublicShareExportDefinition = {}));
/**
 * Share active status
 */


var KpkApiPublicShareStatus;

(function (KpkApiPublicShareStatus) {
  KpkApiPublicShareStatus["Activated"] = "ACTIVATED";
  KpkApiPublicShareStatus["Deactivated"] = "DEACTIVATED";
})(KpkApiPublicShareStatus || (KpkApiPublicShareStatus = {}));

var KpkApiHitConnectionMode;

(function (KpkApiHitConnectionMode) {
  KpkApiHitConnectionMode["Anonymous"] = "ANONYMOUS";
  KpkApiHitConnectionMode["Classic"] = "CLASSIC";
  KpkApiHitConnectionMode["Sso"] = "SSO";
})(KpkApiHitConnectionMode || (KpkApiHitConnectionMode = {}));

var KpkApiHitSearchType;

(function (KpkApiHitSearchType) {
  KpkApiHitSearchType["Advanced"] = "ADVANCED";
  KpkApiHitSearchType["Folder"] = "FOLDER";
  KpkApiHitSearchType["Form"] = "FORM";
  KpkApiHitSearchType["Geoloc"] = "GEOLOC";
  KpkApiHitSearchType["Individual"] = "INDIVIDUAL";
  KpkApiHitSearchType["Kpk360"] = "KPK360";
  KpkApiHitSearchType["List"] = "LIST";
  KpkApiHitSearchType["Text"] = "TEXT";
})(KpkApiHitSearchType || (KpkApiHitSearchType = {}));

var KpkApiHitHitType;

(function (KpkApiHitHitType) {
  KpkApiHitHitType["Connection"] = "CONNECTION";
  KpkApiHitHitType["Download"] = "DOWNLOAD";
  KpkApiHitHitType["Play"] = "PLAY";
  KpkApiHitHitType["Search"] = "SEARCH";
  KpkApiHitHitType["Upload"] = "UPLOAD";
  KpkApiHitHitType["View"] = "VIEW";
})(KpkApiHitHitType || (KpkApiHitHitType = {}));

var KpkApiHitContributionSpaceType;

(function (KpkApiHitContributionSpaceType) {
  KpkApiHitContributionSpaceType["Basket"] = "BASKET";
  KpkApiHitContributionSpaceType["Folder"] = "FOLDER";
  KpkApiHitContributionSpaceType["Wall"] = "WALL";
})(KpkApiHitContributionSpaceType || (KpkApiHitContributionSpaceType = {}));

var KpkApiAttachmentCloudProviderState;

(function (KpkApiAttachmentCloudProviderState) {
  KpkApiAttachmentCloudProviderState["Offline"] = "OFFLINE";
  KpkApiAttachmentCloudProviderState["Online"] = "ONLINE";
  KpkApiAttachmentCloudProviderState["PendingToOnline"] = "PENDING_TO_ONLINE";
})(KpkApiAttachmentCloudProviderState || (KpkApiAttachmentCloudProviderState = {}));
/**
 * attachment type
 */


var KpkApiAttachmentType;

(function (KpkApiAttachmentType) {
  KpkApiAttachmentType["Document"] = "DOCUMENT";
  KpkApiAttachmentType["Image"] = "IMAGE";
  KpkApiAttachmentType["Link"] = "LINK";
  KpkApiAttachmentType["Other"] = "OTHER";
  KpkApiAttachmentType["Sound"] = "SOUND";
  KpkApiAttachmentType["Video"] = "VIDEO";
})(KpkApiAttachmentType || (KpkApiAttachmentType = {}));

/**
 * Group type
 */
var Type;

(function (Type) {
  Type["Administrator"] = "ADMINISTRATOR";
  Type["Manager"] = "MANAGER";
  Type["Visitor"] = "VISITOR";
  Type["Writer"] = "WRITER";
})(Type || (Type = {}));

/**
 * Share export definition
 */
var KpkApiShareTokenExportDefinition;

(function (KpkApiShareTokenExportDefinition) {
  KpkApiShareTokenExportDefinition["Bd"] = "BD";
  KpkApiShareTokenExportDefinition["HD"] = "HD";
  KpkApiShareTokenExportDefinition["None"] = "NONE";
})(KpkApiShareTokenExportDefinition || (KpkApiShareTokenExportDefinition = {}));

/**
 * Profile authorization enum
 */
var KpkApiProfileAuthorization;

(function (KpkApiProfileAuthorization) {
  KpkApiProfileAuthorization["Administrator"] = "ADMINISTRATOR";
  KpkApiProfileAuthorization["Frontoffice"] = "FRONTOFFICE";
  KpkApiProfileAuthorization["Import"] = "IMPORT";
  KpkApiProfileAuthorization["PublicShare"] = "PUBLIC_SHARE";
  KpkApiProfileAuthorization["Statistic"] = "STATISTIC";
  KpkApiProfileAuthorization["TechAdministrator"] = "TECH_ADMINISTRATOR";
  KpkApiProfileAuthorization["Thesaurus"] = "THESAURUS";
  KpkApiProfileAuthorization["Trash"] = "TRASH";
  KpkApiProfileAuthorization["Attachments"] = "ATTACHMENTS";
  KpkApiProfileAuthorization["DynameekWrite"] = "DYNAMEEK_WRITE";
})(KpkApiProfileAuthorization || (KpkApiProfileAuthorization = {}));

var KpkApiOrientationContactSheet;

(function (KpkApiOrientationContactSheet) {
  KpkApiOrientationContactSheet["PORTRAIT"] = "PORTRAIT";
  KpkApiOrientationContactSheet["LANDSCAPE"] = "LANDSCAPE";
})(KpkApiOrientationContactSheet || (KpkApiOrientationContactSheet = {}));

/**
 * Share export definition
 */
var KpkApiPublicShareTokenExportDefinition;

(function (KpkApiPublicShareTokenExportDefinition) {
  KpkApiPublicShareTokenExportDefinition["Bd"] = "BD";
  KpkApiPublicShareTokenExportDefinition["HD"] = "HD";
  KpkApiPublicShareTokenExportDefinition["None"] = "NONE";
})(KpkApiPublicShareTokenExportDefinition || (KpkApiPublicShareTokenExportDefinition = {}));

/**
 * Type of value property (json types except ARRAY and NULL)
 */
var KpkApiAdditionalAttributeType;

(function (KpkApiAdditionalAttributeType) {
  KpkApiAdditionalAttributeType["Boolean"] = "BOOLEAN";
  KpkApiAdditionalAttributeType["Number"] = "NUMBER";
  KpkApiAdditionalAttributeType["Object"] = "OBJECT";
  KpkApiAdditionalAttributeType["String"] = "STRING";
})(KpkApiAdditionalAttributeType || (KpkApiAdditionalAttributeType = {}));

/**
 * format of the thumbnail template
 */
var KpkApiThumbnailTemplateFormat;

(function (KpkApiThumbnailTemplateFormat) {
  KpkApiThumbnailTemplateFormat["Jpeg"] = "jpeg";
  KpkApiThumbnailTemplateFormat["Png"] = "png";
  KpkApiThumbnailTemplateFormat["Webp"] = "webp";
})(KpkApiThumbnailTemplateFormat || (KpkApiThumbnailTemplateFormat = {}));

var KpkApiThumbnailTemplatePermission;

(function (KpkApiThumbnailTemplatePermission) {
  KpkApiThumbnailTemplatePermission["Write"] = "WRITE";
  KpkApiThumbnailTemplatePermission["Read"] = "READ";
})(KpkApiThumbnailTemplatePermission || (KpkApiThumbnailTemplatePermission = {}));

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    _construct = Reflect.construct;
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) _setPrototypeOf(instance, Class.prototype);
      return instance;
    };
  }

  return _construct.apply(null, arguments);
}

function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;

  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;

    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }

    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);

      _cache.set(Class, Wrapper);
    }

    function Wrapper() {
      return _construct(Class, arguments, _getPrototypeOf(this).constructor);
    }

    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf(Wrapper, Class);
  };

  return _wrapNativeSuper(Class);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

/**
 * Custom Kpk api client exception class
 */
var KpkApiError = /*#__PURE__*/function (_Error) {
  _inheritsLoose(KpkApiError, _Error);

  function KpkApiError() {
    return _Error.apply(this, arguments) || this;
  }

  return KpkApiError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

/**
 * Utility class to build query parameters for media search
 * Advanced and Simple search
 */

var KpkApiBuildQueryParametersUtils = /*#__PURE__*/function () {
  function KpkApiBuildQueryParametersUtils() {}

  /**
   * Construct query params with Keepeek API specification
   * @param params search medias query parameters informations
   */
  KpkApiBuildQueryParametersUtils.buildSearchQueryParameters = function buildSearchQueryParameters(params) {
    if (params === null || params === undefined) {
      throw new KpkApiError("params is null or undefined");
    }

    var queryParameters = this.buildPagedQueryParameters(params);

    if (params.q !== undefined && params.q !== null) {
      queryParameters.set("q", params.q);
    }

    if (params.f) {
      params.f.forEach(function (element) {
        queryParameters.append("f", element);
      });
    }

    if (params.fq) {
      params.fq.forEach(function (element) {
        queryParameters.append("fq", element);
      });
    }

    if (params.sort !== undefined && params.sort !== null) {
      queryParameters.set("sort", params.sort);
    }

    if (params.fields !== undefined && params.fields !== null) {
      queryParameters.set("fields", params.fields);
    }

    if (params.notFoundReference !== undefined && params.notFoundReference !== null) {
      queryParameters.set("notFoundReference", params.notFoundReference);
    }

    if (params.embeddedFolders !== undefined && params.embeddedFolders !== null) {
      queryParameters.set("embeddedFolders", params.embeddedFolders);
    }

    if (params.facetFields !== undefined && params.facetFields !== null) {
      if (params.facetFields.length === 0) {
        // we must here explicitly indicate an empty array in string
        // so that it is indeed sent to the API in this way otherwise it will send this parameter with an empty value
        queryParameters.set("facet-fields", "[]");
      } else {
        queryParameters.set("facet-fields", params.facetFields);
      }
    }

    return queryParameters;
  }
  /**
   * Build query parameters for paged search folder query
   * @param params paged query parameters informations
   */
  ;

  KpkApiBuildQueryParametersUtils.buildSearchFolderQueryParameters = function buildSearchFolderQueryParameters(params) {
    if (params === null || params === undefined) {
      throw new KpkApiError("params is null or undefined");
    }

    var queryParameters = this.buildSearchQueryParameters(params);

    if (params.withChildrenList !== undefined && params.withChildrenList !== null) {
      queryParameters.set("withChildrenList", params.withChildrenList === true ? "true" : "false");
    }

    if (params.countMedias !== undefined && params.countMedias !== null) {
      queryParameters.set("countMedias", params.countMedias === true ? "true" : "false");
    }

    return queryParameters;
  }
  /**
   * Build query parameters for paged query
   * @param params paged query parameters informations
   */
  ;

  KpkApiBuildQueryParametersUtils.buildPagedQueryParameters = function buildPagedQueryParameters(params) {
    if (params === null || params === undefined) {
      throw new KpkApiError("params is null or undefined");
    }

    var queryParameters = new URLSearchParams();

    if (params.page !== undefined && params.page !== null) {
      queryParameters.set("page", params.page);
    }

    if (params.size !== undefined && params.size !== null) {
      queryParameters.set("size", params.size);
    }

    queryParameters.set("forceArrays", params.forceArrays === undefined ? "true" : params.forceArrays);
    return queryParameters;
  }
  /**
   * Build query parameters for standard query
   * @param params standard query parameters informations
   */
  ;

  KpkApiBuildQueryParametersUtils.buildQueryParameters = function buildQueryParameters(params) {
    if (params === null || params === undefined) {
      throw new KpkApiError("params is null or undefined");
    }

    var queryParameters = new URLSearchParams();
    queryParameters.set("forceArrays", params.forceArrays === undefined ? "true" : params.forceArrays);
    return queryParameters;
  }
  /**
   * Build query parameters for boolean
   */
  ;

  KpkApiBuildQueryParametersUtils.buildBooleanQueryParameter = function buildBooleanQueryParameter(parameterName, value) {
    var queryParameters = new URLSearchParams();
    queryParameters.set(parameterName, value);
    return queryParameters;
  };

  return KpkApiBuildQueryParametersUtils;
}();

/**
 * Search media
 * Returns a paginated list of medias.
 */

function searchMedias(axios, params) {
  return axios.get("/api/dam/search/media", _extends({
    params: KpkApiBuildQueryParametersUtils.buildSearchQueryParameters(params)
  }, params.axiosRequestConfig));
}
/**
 * Search baskets
 * Returns a paginated list of baskets.
 */

function searchBaskets(axios, params) {
  return axios.get("/api/dam/search/basket", _extends({
    params: KpkApiBuildQueryParametersUtils.buildSearchQueryParameters(params)
  }, params.axiosRequestConfig));
}
/**
 * Search users
 * Returns a paginated list of users.
 */

function searchUsers(axios, params) {
  return axios.get("/api/dam/search/user", _extends({
    params: KpkApiBuildQueryParametersUtils.buildSearchQueryParameters(params)
  }, params.axiosRequestConfig));
}
/**
 * Autocomplete search
 * Returns autocomplete result
 */

function autocomplete(axios, params) {
  var paramsToUse = KpkApiBuildQueryParametersUtils.buildQueryParameters(params);

  if (params.folder) {
    params.folder.forEach(function (folder) {
      paramsToUse.append("folder", folder);
    });
  }

  if (params.field) {
    params.field.forEach(function (field) {
      paramsToUse.append("field", field);
    });
  }

  if (params.type) {
    params.type.forEach(function (type) {
      paramsToUse.append("type", type);
    });
  }

  if (params.q) {
    paramsToUse.set("q", params.q);
  }

  if (params.limit) {
    paramsToUse.set("limit", params.limit);
  }

  if (params.thesaurusId) {
    paramsToUse.set("thesaurusId", params.thesaurusId);
  }

  return axios.get("/api/dam/search/autocomplete", _extends({
    params: paramsToUse
  }, params.axiosRequestConfig));
}
/**
 * Create an advanced search resource
 * @param params contains headers and filter information
 */

function createAdvancedSearch(axios, params) {
  if (!params || !params.filter) {
    return Promise.reject(new KpkApiError("params.filter is null or undefined"));
  }

  return axios.post("api/dam/search/advanced", {
    _embedded: {
      filter: params.filter,
      notFoundReference: params.notFoundReference === undefined ? false : params.notFoundReference
    }
  }, params.axiosRequestConfig);
}
/**
 * Get advanced search filtered media resource list
 * @param params contains headers informations and technical identifier of the advanced search
 */

function getAdvancedSearch(axios, params) {
  if (!params || !params.advancedSearchId) {
    return Promise.reject(new KpkApiError("params.advancedSearchId is null or undefined"));
  }

  return axios.get("api/dam/search/advanced/" + encodeURIComponent(params.advancedSearchId) + "/media", _extends({
    params: KpkApiBuildQueryParametersUtils.buildSearchQueryParameters(params)
  }, params.axiosRequestConfig));
}
/**
 * Get advanced search criterias
 * Returns a paginated list of advanced search criterias.
 */

function getAdvancedSearchCriterias(axios, params) {
  return axios.get("api/dam/search/advanced/criterias", _extends({
    params: KpkApiBuildQueryParametersUtils.buildPagedQueryParameters(params)
  }, params.axiosRequestConfig));
}
/**
 * Get advanced search criteria by id
 * Returns a canonical representation of the advanced search criteria.
 */

function getAdvancedSearchCriteria(axios, params) {
  if (!params || !params.criteriaId) {
    return Promise.reject(new KpkApiError("params.criteriaId is null or undefined"));
  }

  return axios.get("api/dam/search/advanced/criterias/" + encodeURIComponent(params.criteriaId), _extends({
    params: KpkApiBuildQueryParametersUtils.buildPagedQueryParameters(params)
  }, params.axiosRequestConfig));
}
/**
 * Get search folders
 * Returns a list of folders.
 */

function getSearchFolders(axios, params) {
  if (!params) {
    return Promise.reject(new KpkApiError("params is undefined"));
  }

  var adaptedParams = params;

  if (params.folderIds) {
    if (params.folderIds.length === 1) {
      adaptedParams = _extends({}, adaptedParams, {
        fq: ["folderId:" + params.folderIds[0]]
      });
    } else {
      adaptedParams = _extends({}, adaptedParams, {
        fq: ["folderId:(" + params.folderIds.join(" ") + ")"]
      });
    }
  }

  return axios.get("api/dam/search/folder", _extends({
    params: KpkApiBuildQueryParametersUtils.buildSearchFolderQueryParameters(adaptedParams)
  }, params.axiosRequestConfig));
}

function getMediaFolders(axios, params) {
  if (!params || !params.mediaId) {
    return Promise.reject(new KpkApiError("params.mediaId is null or undefined"));
  }

  return axios.get("api/dam/medias/" + params.mediaId + "/folders", _extends({
    params: KpkApiBuildQueryParametersUtils.buildSearchQueryParameters(params)
  }, params.axiosRequestConfig));
}
function getMediaAttachments(axios, params) {
  if (!params || !params.mediaId) {
    return Promise.reject(new KpkApiError("params.mediaId is null or undefined"));
  }

  return axios.get("api/dam/medias/" + params.mediaId + "/attachments", _extends({
    params: KpkApiBuildQueryParametersUtils.buildSearchQueryParameters(params)
  }, params.axiosRequestConfig));
}
function getMediaSharePublic(axios, params) {
  if (!params || !params.mediaId) {
    return Promise.reject(new KpkApiError("params.mediaId is null or undefined"));
  }

  return axios.get("api/dam/medias/" + params.mediaId + "/share/public", _extends({
    params: KpkApiBuildQueryParametersUtils.buildSearchQueryParameters(params)
  }, params.axiosRequestConfig));
}
function updateMediaSharePublic(axios, params) {
  if (!params || !params.mediaId || !params.sharePublic) {
    return Promise.reject(new KpkApiError("params.mediaId or params.status is null or undefined"));
  }

  return axios.put("api/dam/medias/" + params.mediaId + "/share/public", params.sharePublic, params.axiosRequestConfig);
}
function getMediaShareTokens(axios, params) {
  if (!params || !params.mediaId) {
    return Promise.reject(new KpkApiError("params.mediaId is null or undefined"));
  }

  return axios.get("api/dam/medias/" + params.mediaId + "/share/tokens", _extends({
    params: KpkApiBuildQueryParametersUtils.buildSearchQueryParameters(params)
  }, params.axiosRequestConfig));
}
function createMediaShareToken(axios, params) {
  if (!params || !params.mediaId || !params.shareToken) {
    return Promise.reject(new KpkApiError("params.mediaId or params.shareToken is null or undefined"));
  }

  return axios.post("api/dam/medias/" + params.mediaId + "/share/tokens", params.shareToken, params.axiosRequestConfig);
}
function deleteMediaShareToken(axios, params) {
  if (!params || !params.mediaId || !params.shareTokenId) {
    return Promise.reject(new KpkApiError("params.mediaId or params.shareTokenId is null or undefined"));
  }

  return axios["delete"]("api/dam/medias/" + params.mediaId + "/share/tokens/" + params.shareTokenId, _extends({
    params: params
  }, params.axiosRequestConfig));
}
function updateMediaShareToken(axios, params) {
  if (!params || !params.mediaId || !params.shareToken) {
    return Promise.reject(new KpkApiError("params.mediaId or params.shareToken is null or undefined"));
  }

  return axios.put("api/dam/medias/" + params.mediaId + "/share/tokens/" + params.shareToken.tokenValue, params.shareToken, params.axiosRequestConfig);
}
function getMediaAttachment(axios, params) {
  if (!params || !params.mediaId || !params.attachmentId) {
    return Promise.reject(new KpkApiError("params.mediaId OR params.attachmentId is null or undefined"));
  }

  return axios.get("api/dam/medias/" + params.mediaId + "/attachments/" + params.attachmentId, _extends({
    params: KpkApiBuildQueryParametersUtils.buildSearchQueryParameters(params)
  }, params.axiosRequestConfig));
}
function createMediaAttachmentDownloadLink(axios, params) {
  if (!params || !params.mediaId || !params.attachmentId) {
    return Promise.reject(new KpkApiError("params.mediaId OR params.attachmentId is null or undefined"));
  }

  return axios.post("api/dam/medias/" + params.mediaId + "/attachments/" + params.attachmentId + "/download-link", null, _extends({
    params: KpkApiBuildQueryParametersUtils.buildSearchQueryParameters(params)
  }, params.axiosRequestConfig));
}
function createMediaAttachmentUri(axios, params) {
  if (!params || !params.mediaId || !params.attachmentId) {
    return Promise.reject(new KpkApiError("params.mediaId OR params.attachmentId is null or undefined"));
  }

  return axios.post("api/dam/medias/" + params.mediaId + "/attachments/" + params.attachmentId + "/download-link?linkType=kpk", null, _extends({
    params: KpkApiBuildQueryParametersUtils.buildSearchQueryParameters(params)
  }, params.axiosRequestConfig));
}
function getMediaPlayer(axios, params) {
  if (!params || !params.mediaId) {
    return Promise.reject(new KpkApiError("params.mediaId is null or undefined"));
  }

  return axios.get("api/dam/medias/" + params.mediaId + "/player", _extends({
    params: KpkApiBuildQueryParametersUtils.buildSearchQueryParameters(params)
  }, params.axiosRequestConfig));
}
function getMediaEmbed(axios, params) {
  if (!params || !params.mediaId) {
    return Promise.reject(new KpkApiError("params.mediaId is null or undefined"));
  }

  return axios.get("api/dam/medias/" + params.mediaId + "/embed", _extends({
    params: KpkApiBuildQueryParametersUtils.buildSearchQueryParameters(params)
  }, params.axiosRequestConfig));
}
function getMedia(axios, params) {
  if (!params || !params.mediaId) {
    return Promise.reject(new KpkApiError("params.mediaId is null or undefined"));
  }

  return axios.get("api/dam/medias/" + params.mediaId, _extends({
    params: KpkApiBuildQueryParametersUtils.buildSearchQueryParameters(params)
  }, params.axiosRequestConfig));
}
function postMedia(axios, params) {
  if (!params || !params.fileUrl) {
    return Promise.reject(new KpkApiError("params.fileUrl is null or undefined"));
  }

  return axios.post("api/dam/medias", {
    _links: _extends({
      from: {
        href: params.fileUrl
      }
    }, params.formId && {
      "kpk:form": "api/dam/forms/" + params.formId
    })
  }, _extends({
    params: KpkApiBuildQueryParametersUtils.buildSearchQueryParameters(params)
  }, params.axiosRequestConfig));
}
function updateMedia(axios, params) {
  if (!params || !params.id) {
    return Promise.reject(new KpkApiError("params or params.id is null or undefined"));
  }

  return axios.put("api/dam/medias/" + params.id, {
    id: params.id,
    status: params.status,
    annotation: params.annotation,
    duplicationStatus: params.duplicationStatus,
    pointOfInterest: params.pointOfInterest
  }, params.axiosRequestConfig);
}

/**
 * Get sheet fields
 * Returns a paginated list of sheet fields.
 */

function getSheetFields(axios, params) {
  return axios.get("/api/dam/sheet-fields", _extends({
    params: KpkApiBuildQueryParametersUtils.buildSearchQueryParameters(params)
  }, params.axiosRequestConfig));
}
/**
 * Get sheet field by id
 * Returns a canonical representation of the sheetField.
 */

function getSheetField(axios, params) {
  if (!params || !params.sheetFieldId) {
    return Promise.reject(new KpkApiError("params.sheetFieldId is null or undefined"));
  }

  return axios.get("/api/dam/sheet-fields/" + encodeURIComponent(String(params.sheetFieldId)), _extends({
    params: KpkApiBuildQueryParametersUtils.buildSearchQueryParameters(params)
  }, params.axiosRequestConfig));
}

/**
 * Get forms
 * Returns a paginated list of forms.
 */

function getForms(axios, params) {
  return axios.get("/api/dam/forms", _extends({
    params: KpkApiBuildQueryParametersUtils.buildSearchQueryParameters(params)
  }, params.axiosRequestConfig));
}
/**
 * Get lookups
 * Returns a paginated list of lookups.
 */

function getLookups(axios, params) {
  return axios.get("/api/dam/forms/lookups", _extends({
    params: KpkApiBuildQueryParametersUtils.buildSearchQueryParameters(params)
  }, params.axiosRequestConfig));
}
/**
 * Get form fields by form id
 * Returns a paginated list of form fields.
 */

function getFormFields(axios, params) {
  if (!params || !params.formId) {
    return Promise.reject(new KpkApiError("params.formId is null or undefined"));
  }

  return axios.get("/api/dam/forms/" + encodeURIComponent(String(params.formId)) + "/fields", _extends({
    params: KpkApiBuildQueryParametersUtils.buildSearchQueryParameters(params)
  }, params.axiosRequestConfig));
}
/**
 * Get form by id
 * Returns a canonical representation of the form.
 */

function getForm(axios, params) {
  if (!params || !params.formId) {
    return Promise.reject(new KpkApiError("params.formId is null or undefined"));
  }

  return axios.get("/api/dam/forms/" + encodeURIComponent(String(params.formId)), _extends({
    params: KpkApiBuildQueryParametersUtils.buildQueryParameters(params)
  }, params.axiosRequestConfig));
}
/**
 * Get formField by form id and formField id
 * Returns a canonical representation of the form field.
 */

function getFormField(axios, params) {
  if (!params || !params.formId || !params.fieldId) {
    return Promise.reject(new KpkApiError("params.formId OR params.fieldId is null or undefined"));
  }

  return axios.get("/api/dam/forms/" + encodeURIComponent(String(params.formId)) + "/fields/" + encodeURIComponent(String(params.fieldId)), _extends({
    params: KpkApiBuildQueryParametersUtils.buildQueryParameters(params)
  }, params.axiosRequestConfig));
}
/**
 * Get lookup by id
 * Returns a canonical representation of the lookup.
 */

function getLookup(axios, params) {
  if (!params || !params.lookupId) {
    return Promise.reject(new KpkApiError("params.lookupId is null or undefined"));
  }

  return axios.get("/api/dam/forms/lookups/" + encodeURIComponent(String(params.lookupId)), _extends({
    params: KpkApiBuildQueryParametersUtils.buildQueryParameters(params)
  }, params.axiosRequestConfig));
}

/**
 * Get dam
 * Returns a canonical representation of dam
 */
function getDam(axios, params) {
  return axios.get("/api/dam", params == null ? void 0 : params.axiosRequestConfig);
}

/**
 * Utility class to apply transformations on api response
 */
var KpkApiResponseUtils = /*#__PURE__*/function () {
  function KpkApiResponseUtils() {}

  /**
   * Return an entity id from href value
   * @param href
   */
  KpkApiResponseUtils.extractEntityIdFromHref = function extractEntityIdFromHref(href) {
    if (href && href.includes("/")) {
      var pos = href.lastIndexOf("/");

      if (href.length > pos + 1) {
        return href.substring(href.lastIndexOf("/") + 1).split(/[?#]/)[0];
      }
    }

    return null;
  };

  return KpkApiResponseUtils;
}();

var _excluded$2 = ["axiosRequestConfig"],
    _excluded2 = ["axiosRequestConfig"];
/**
 * Get current user
 * note: This call add a getDam call to know the user ID autonomously
 * Returns a canonical representation of the current user.
 */

var getCurrentUser = function getCurrentUser(axios, params) {
  try {
    return Promise.resolve(getDam(axios, params)).then(function (_getDam) {
      var kpkApiDam = _getDam.data;

      if (kpkApiDam) {
        if (kpkApiDam && kpkApiDam._links && kpkApiDam._links["kpk:current-user"]) {
          var userIdStr = KpkApiResponseUtils.extractEntityIdFromHref(kpkApiDam._links["kpk:current-user"].href);

          if (userIdStr) {
            return getUser(axios, _extends({
              userId: +userIdStr
            }, params));
          }
        }
      }

      return Promise.reject(new KpkApiError("Cannot get current user"));
    });
  } catch (e) {
    return Promise.reject(e);
  }
};
/**
 * Get user
 * Returns a canonical representation of the user.
 */

function getUser(axios, params) {
  if (!params || !params.userId) {
    return Promise.reject(new KpkApiError("params.userId is null or undefined"));
  }

  return axios.get("/api/dam/users/" + encodeURIComponent(String(params.userId)), params.axiosRequestConfig);
}
/**
 * Update user
 */

function updateUser(axios, params) {
  if (!params || !params.id) {
    return Promise.reject(new KpkApiError("params or params.id is null or undefined"));
  }

  return axios.put("/api/dam/users/" + params.id, params, _extends({
    params: KpkApiBuildQueryParametersUtils.buildBooleanQueryParameter("notifyUpdate", params.notifyUpdate)
  }, params.axiosRequestConfig));
}
/**
 * Get selections
 * Returns a list of selections.
 */

function getUserSelections(axios, params) {
  if (!params || !params.userId) {
    return Promise.reject(new KpkApiError("params.userId is null or undefined"));
  }

  return axios.get("/api/dam/users/" + encodeURIComponent(String(params.userId)) + "/selections", _extends({
    params: KpkApiBuildQueryParametersUtils.buildPagedQueryParameters(params)
  }, params.axiosRequestConfig));
}
function createUserAdditionalAttribute(axios, params) {
  if (!params || !params.userId || !params.attributes) {
    return Promise.reject(new KpkApiError("params.userId is null or undefined, params.attributes is null or undefined"));
  }

  var attributes = params.attributes,
      schemas = params.schemas;
  return axios.post("/api/dam/users/" + encodeURIComponent(String(params.userId)) + "/additional-attributes", {
    attributes: attributes,
    schemas: schemas
  }, params.axiosRequestConfig);
}
function updateUserAdditionalAttribute(axios, params) {
  if (!params || !params.userId || !params.attribute) {
    return Promise.reject(new KpkApiError("params.userId is null or undefined, params.attribute is null or undefined"));
  }

  var attribute = params.attribute;
  return axios.put("/api/dam/users/" + encodeURIComponent(String(params.userId)) + "/additional-attributes/" + encodeURIComponent(String(params.attribute.id)), {
    value: attribute.value
  }, params.axiosRequestConfig);
}
/**
 * Create a selection
 * Returns a selection Id, expiration date and a media count of the created selection.
 */

function postUserSelection(axios, params) {
  if (!params || !params.userId) {
    return Promise.reject(new KpkApiError("params.userId is null or undefined"));
  }

  return axios.post("/api/dam/users/" + encodeURIComponent(String(params.userId)) + "/selections", null, params.axiosRequestConfig);
}
function postUserSelectionBulk(axios, params) {
  if (!params || !params.userId || !params.selectionId || !params.metadata) {
    return Promise.reject(new KpkApiError("params.userId or params.selectionId or params.metadata are null or undefined"));
  }

  return axios.post("/api/dam/users/" + encodeURIComponent(String(params.userId)) + "/selections/" + encodeURIComponent(params.selectionId) + "/bulks", {
    _embedded: {
      metadata: [].concat(params.metadata)
    }
  }, params.axiosRequestConfig);
}
function getUserSelectionBulkFields(axios, params) {
  if (!params || !params.userId || !params.selectionId) {
    return Promise.reject(new KpkApiError("params.userId or params.selectionId are null or undefined"));
  }

  return axios.get("/api/dam/users/" + encodeURIComponent(String(params.userId)) + "/selections/" + encodeURIComponent(params.selectionId) + "/bulks/fields", _extends({
    params: KpkApiBuildQueryParametersUtils.buildSearchQueryParameters(params)
  }, params.axiosRequestConfig));
}
/**
 * Delete a selection
 * Remove a selection from the collection. Idempotent method
 */

function deleteUserSelection(axios, params) {
  if (!params || !params.userId) {
    return Promise.reject(new KpkApiError("params.userId is null or undefined"));
  }

  if (!params || !params.selectionId) {
    return Promise.reject(new KpkApiError("params.selectionId is null or undefined"));
  }

  return axios["delete"]("/api/dam/users/" + encodeURIComponent(String(params.userId)) + "/selections/" + encodeURIComponent(String(params.selectionId)), params.axiosRequestConfig);
}
/**
 * Get selection by id
 * Returns a canonical representation of the selection.
 */

function getUserSelection(axios, params) {
  if (!params || !params.userId) {
    return Promise.reject(new KpkApiError("params.userId is null or undefined"));
  }

  if (!params || !params.selectionId) {
    return Promise.reject(new KpkApiError("params.selectionId is null or undefined"));
  }

  return axios.get("/api/dam/users/" + encodeURIComponent(String(params.userId)) + "/selections/" + encodeURIComponent(String(params.selectionId)), _extends({
    params: KpkApiBuildQueryParametersUtils.buildQueryParameters(params)
  }, params.axiosRequestConfig));
}
/**
 * Get selection available export formats for selected medias
 * Returns a list of media types with available export formats.
 */

function getUserSelectionAvailableExportFormats(axios, params) {
  if (!params || !params.userId) {
    return Promise.reject(new KpkApiError("params.userId is null or undefined"));
  }

  if (!params || !params.selectionId) {
    return Promise.reject(new KpkApiError("params.selectionId is null or undefined"));
  }

  var queryParams = KpkApiBuildQueryParametersUtils.buildQueryParameters(params);

  if (params.groupBy) {
    queryParams.set("groupBy", params.groupBy);
  }

  return axios.get("/api/dam/users/" + encodeURIComponent(String(params.userId)) + "/selections/" + encodeURIComponent(String(params.selectionId)) + "/available-export-formats", _extends({
    params: queryParams
  }, params.axiosRequestConfig));
}
function getUserSelectionMedias(axios, params) {
  if (!params || !params.userId) {
    return Promise.reject(new KpkApiError("params.userId is null or undefined"));
  }

  if (!params || !params.selectionId) {
    return Promise.reject(new KpkApiError("params.selectionId is null or undefined"));
  }

  return axios.get("/api/dam/users/" + encodeURIComponent(String(params.userId)) + "/selections/" + encodeURIComponent(String(params.selectionId)) + "/medias", _extends({
    params: KpkApiBuildQueryParametersUtils.buildSearchQueryParameters(params)
  }, params.axiosRequestConfig));
}
function getUserSelectionMediasTermsOfUse(axios, params) {
  if (!params || !params.userId) {
    return Promise.reject(new KpkApiError("params.userId is null or undefined"));
  }

  if (!params || !params.selectionId) {
    return Promise.reject(new KpkApiError("params.selectionId is null or undefined"));
  }

  return axios.get("/api/dam/users/" + encodeURIComponent(String(params.userId)) + "/selections/" + encodeURIComponent(String(params.selectionId)) + "/terms-of-use", _extends({
    params: KpkApiBuildQueryParametersUtils.buildSearchQueryParameters(params)
  }, params.axiosRequestConfig));
}
/**
 * Post medias collections by ids into a user selection
 * Returns a success or mixed status if error or partial error.
 */

function postUserSelectionMediasCollection(axios, params) {
  if (!params || !params.userId) {
    return Promise.reject(new KpkApiError("params.userId is null or undefined"));
  }

  if (!params || !params.selectionId) {
    return Promise.reject(new KpkApiError("params.selectionId is null or undefined"));
  }

  if (!params || !params.mediaIds) {
    return Promise.reject(new KpkApiError("params.mediaIds is null or undefined"));
  }

  var queryParams = KpkApiBuildQueryParametersUtils.buildQueryParameters(params);

  if (params.asAdmin) {
    queryParams.set("as-admin", "" + params.asAdmin);
  }

  return axios.post("/api/dam/users/" + encodeURIComponent(String(params.userId)) + "/selections/" + encodeURIComponent(String(params.selectionId)) + "/medias-collection", {
    ids: params.mediaIds
  }, _extends({
    params: queryParams
  }, params.axiosRequestConfig));
}
/**
 * Delete medias collections by ids of a user selection
 * Returns a success or mixed status if error or partial error.
 */

function deleteUserSelectionMediasCollection(axios, params) {
  if (!params || !params.userId) {
    return Promise.reject(new KpkApiError("params.userId is null or undefined"));
  }

  if (!params || !params.selectionId) {
    return Promise.reject(new KpkApiError("params.selectionId is null or undefined"));
  }

  if (!params || !params.mediaIds) {
    return Promise.reject(new KpkApiError("params.mediaIds is null or undefined"));
  }

  var queryParams = KpkApiBuildQueryParametersUtils.buildQueryParameters(params);

  if (params.asAdmin) {
    queryParams.set("as-admin", "" + params.asAdmin);
  } // Use axios function because the shorthand "delete" function does not accept body/data


  return axios(_extends({
    method: "DELETE",
    url: "/api/dam/users/" + encodeURIComponent(String(params.userId)) + "/selections/" + encodeURIComponent(String(params.selectionId)) + "/medias-collection",
    data: {
      ids: params.mediaIds
    },
    params: queryParams
  }, params.axiosRequestConfig));
} // Assigned Groups

/**
 * Get assigned groups
 * Returns a list of assigned groups.
 */

function getUserAssignedGroups(axios, params) {
  if (!params || !params.userId) {
    return Promise.reject(new KpkApiError("params.userId is null or undefined"));
  }

  return axios.get("/api/dam/users/" + params.userId + "/assigned-groups", _extends({
    params: KpkApiBuildQueryParametersUtils.buildQueryParameters(params)
  }, params.axiosRequestConfig));
}
/**
 * Get assigned group
 * Returns an assigned group.
 */

function getUserAssignedGroup(axios, params) {
  if (!params || !params.userId || !params.assignedGroupId) {
    return Promise.reject(new KpkApiError("params.userId is null or undefined or params.assignedGroupId is null or undefined"));
  }

  return axios.get("/api/dam/users/" + params.userId + "/assigned-groups/" + params.assignedGroupId, _extends({}, params.axiosRequestConfig));
}
/**
 * Update user assigned group
 */

function updateUserAssignedGroup(axios, params) {
  if (!params || !params.userId || !params.assignedGroup || !params.assignedGroup.id) {
    return Promise.reject(new KpkApiError("params.userId or params.assignedGroup is null or undefined or params.assignedGroup.id is null or undefined"));
  }

  return axios.put("/api/dam/users/" + params.userId + "/assigned-groups/" + params.assignedGroup.id, params.assignedGroup, _extends({
    params: KpkApiBuildQueryParametersUtils.buildBooleanQueryParameter("notifyActivation", params.notifyActivation)
  }, params.axiosRequestConfig));
}
/**
 * Assign group to user
 */

function assignGroupToUser(axios, params) {
  if (!params || !params.userId || !params.assignedGroup || !params.assignedGroup.id) {
    return Promise.reject(new KpkApiError("params.userId or params.assignedGroup is null or undefined or params.assignedGroup.id is null or undefined"));
  }

  return axios.post("/api/dam/users/" + params.userId + "/assigned-groups", params.assignedGroup, _extends({
    params: KpkApiBuildQueryParametersUtils.buildBooleanQueryParameter("notifyUpdate", params.notifyUpdate)
  }, params.axiosRequestConfig));
}
/**
 * Remove assigned group from user
 */

function deleteUserAssignedGroup(axios, params) {
  if (!params || !params.userId || !params.assignedGroupId) {
    return Promise.reject(new KpkApiError("params.userId is null or undefined or params.assignedGroupId is null or undefined"));
  }

  return axios["delete"]("/api/dam/users/" + params.userId + "/assigned-groups/" + params.assignedGroupId, _extends({
    params: KpkApiBuildQueryParametersUtils.buildBooleanQueryParameter("notifyUpdate", params.notifyUpdate)
  }, params.axiosRequestConfig));
}
/**
 * Get authorized interfaces
 * Returns a list of authorized interfaces.
 */

function getUserAuthorizedInterfaces(axios, params) {
  if (!params || !params.userId) {
    return Promise.reject(new KpkApiError("params.userId is null or undefined"));
  }

  return axios.get("/api/dam/users/" + params.userId + "/authorized-user-interfaces", _extends({
    params: KpkApiBuildQueryParametersUtils.buildPagedQueryParameters(params)
  }, params.axiosRequestConfig));
}
function getUserAvailableGroups(axios, params) {
  if (!params || !params.userId) {
    return Promise.reject(new KpkApiError("params.userId is null or undefined"));
  }

  return axios.get("/api/dam/users/" + params.userId + "/available-groups", _extends({
    params: KpkApiBuildQueryParametersUtils.buildPagedQueryParameters(params)
  }, params.axiosRequestConfig));
}
function getUserThumbnailTemplates(axios, params) {
  if (!params || !params.userId) {
    return Promise.reject(new KpkApiError("params.userId is null or undefined"));
  }

  return axios.get("/api/dam/users/" + params.userId + "/thumbnail-templates", _extends({
    params: KpkApiBuildQueryParametersUtils.buildPagedQueryParameters(params)
  }, params.axiosRequestConfig));
}
function createUserThumbnailTemplate(axios, params) {
  if (!params || !params.userId || !params.format || !params.height || !params.width || !params.label) {
    return Promise.reject(new KpkApiError("params.userId is null or undefined, params.format is null or undefined, params.height is null or undefined, params.width is null or undefined, params.label is null or undefined,"));
  }

  var axiosRequestConfig = params.axiosRequestConfig,
      rest = _objectWithoutPropertiesLoose(params, _excluded$2);

  return axios.post("/api/dam/users/" + params.userId + "/thumbnail-templates", rest, axiosRequestConfig);
}
function updateUserThumbnailTemplate(axios, params) {
  if (!params || !params.userId || !params.format || !params.height || !params.width || !params.label || !params.id) {
    return Promise.reject(new KpkApiError("params.userId is null or undefined, params.format is null or undefined, params.height is null or undefined, params.width is null or undefined, params.label is null or undefined,params.id is null or undefined"));
  }

  var axiosRequestConfig = params.axiosRequestConfig,
      rest = _objectWithoutPropertiesLoose(params, _excluded2);

  return axios.put("/api/dam/users/" + params.userId + "/thumbnail-templates/" + params.id, rest, axiosRequestConfig);
}
function deleteUserThumbnailTemplate(axios, params) {
  if (!params || !params.userId || !params.id) {
    return Promise.reject(new KpkApiError("params.userId is null or undefined, params.id is null or undefined"));
  }

  return axios["delete"]("/api/dam/users/" + params.userId + "/thumbnail-templates/" + params.id, params.axiosRequestConfig);
}

/**
 * Get folder tree
 * Returns folder nodes under root level. Only read granted folders are included in the response.
 */

function getFolderTree(axios, params) {
  return axios.get("api/dam/folder-tree", params == null ? void 0 : params.axiosRequestConfig);
}
/**
 * Get folder tree node
 * Returns a folder node and its children list. Only read granted folders are included in the response.
 */

function getFolderTreeNode(axios, params) {
  if (!params || !params.folderId) {
    return Promise.reject(new KpkApiError("params.folderId is null or undefined"));
  }

  return axios.get("api/dam/folder-tree/" + params.folderId, _extends({
    params: KpkApiBuildQueryParametersUtils.buildQueryParameters(params)
  }, params.axiosRequestConfig));
}
/**
 * Get folders
 * Returns a paginated list of folders. Only read granted folders are included in the response.
 */

function getFolders(axios, params) {
  return axios.get("api/dam/folders", _extends({
    params: KpkApiBuildQueryParametersUtils.buildSearchQueryParameters(params)
  }, params.axiosRequestConfig));
}
/**
 * Get folder by id
 * Returns a canonical representation of the folder.
 */

function getFolder(axios, params) {
  if (!params || !params.folderId) {
    return Promise.reject(new KpkApiError("params.folderId is null or undefined"));
  }

  return axios.get("api/dam/folders/" + params.folderId, params.axiosRequestConfig);
}
/**
 * Add media to folder
 */

function addMediaToFolder(axios, params) {
  if (!params || !params.folderId) {
    return Promise.reject(new KpkApiError("params.folderId is null or undefined"));
  }

  return axios.post("api/dam/folders/" + params.folderId + "/medias", _extends({}, params.fileUrl && {
    _links: _extends({
      from: {
        href: params.fileUrl
      }
    }, params.formId && {
      "kpk:form": "api/dam/forms/" + params.formId
    })
  }, params.mediaId && {
    id: params.mediaId
  }), _extends({
    params: KpkApiBuildQueryParametersUtils.buildSearchQueryParameters(params)
  }, params.axiosRequestConfig));
}

/**
 * Get scripts
 * Returns a paginated list of scripts.
 */

function getScripts(axios, params) {
  var requestParams = KpkApiBuildQueryParametersUtils.buildPagedQueryParameters(params);

  if (params.type) {
    params.type.forEach(function (t) {
      requestParams.append("type", t);
    });
  }

  return axios.get("/api/dam/scripts", _extends({
    params: requestParams
  }, params.axiosRequestConfig));
}
/**
 * Get script-runs
 * Returns a paginated list of script-runs.
 */

function getScriptRuns(axios, params) {
  return axios.get("/api/dam/script-runs", _extends({
    params: KpkApiBuildQueryParametersUtils.buildPagedQueryParameters(params)
  }, params.axiosRequestConfig));
}
/**
 * Run a script, create a script-run resource
 */

function createScriptRun(axios, params) {
  if (!params || !params.script) {
    return Promise.reject(new KpkApiError("params.script is null or undefined"));
  }

  return axios.post("api/dam/script-runs", params.script, params.axiosRequestConfig);
}

/**
 * Get baskets
 * Returns a paginated list of baskets.
 */

function getBaskets(axios, params) {
  return axios.get("api/dam/baskets", _extends({
    params: KpkApiBuildQueryParametersUtils.buildPagedQueryParameters(params)
  }, params.axiosRequestConfig));
}
/**
 * Get basket by id
 * Returns a canonical representation of the basket.
 */

function getBasket(axios, params) {
  if (!params || !params.basketId) {
    return Promise.reject(new KpkApiError("params.basketId is null or undefined"));
  }

  return axios.get("api/dam/baskets/" + params.basketId, _extends({}, params.axiosRequestConfig));
}
/**
 * Get basket medias
 * Returns a paginated list of medias.
 */

function getBasketMedias(axios, params) {
  return axios.get("/api/dam/baskets/" + params.basketId + "/medias", _extends({
    params: KpkApiBuildQueryParametersUtils.buildSearchQueryParameters(params)
  }, params.axiosRequestConfig));
}
/**
 * Add media to basket
 */

function addMediaToBasket(axios, params) {
  if (!params || !params.basketId || !params.media) {
    return Promise.reject(new KpkApiError("params.basketId or params.media is null or undefined"));
  }

  return axios.post("api/dam/baskets/" + params.basketId + "/medias", params.media, params.axiosRequestConfig);
}
/**
 * Add medias to basket
 */

function addMediasToBasket(axios, params) {
  if (!params || !params.basketId || !params.ids || params.ids.length === 0) {
    return Promise.reject(new KpkApiError("params.basketId or params.ids is null or undefined"));
  }

  return axios.post("api/dam/baskets/" + params.basketId + "/medias-collection", {
    ids: params.ids
  }, params.axiosRequestConfig);
}
/**
 * Remove all medias from basket
 */

function removeAllMediasFromBasket(axios, params) {
  if (!params || !params.basketId) {
    return Promise.reject(new KpkApiError("params.basketId is null or undefined"));
  }

  return axios["delete"]("api/dam/baskets/" + params.basketId + "/medias", params.axiosRequestConfig);
}
/**
 * Remove media from basket
 */

function removeMediaFromBasket(axios, params) {
  if (!params || !params.basketId || !params.mediaId) {
    return Promise.reject(new KpkApiError("params.basketId or params.mediaId is null or undefined"));
  }

  return axios["delete"]("api/dam/baskets/" + params.basketId + "/medias/" + params.mediaId, params.axiosRequestConfig);
}
/**
 * Create a basket
 */

function createBasket(axios, params) {
  if (!params || !params.basket || !params.basket.title) {
    return Promise.reject(new KpkApiError("params.basket or params.basket.title is null or undefined"));
  }

  return axios.post("api/dam/baskets", params.basket, params.axiosRequestConfig);
}
/**
 * Update a basket
 */

function updateBasket(axios, params) {
  if (!params || !params.basket || !params.basket.id || !params.basket.title) {
    return Promise.reject(new KpkApiError("params.basket or params.basket.id or params.basket.title is null or undefined"));
  }

  return axios.put("api/dam/baskets/" + params.basket.id, params.basket, params.axiosRequestConfig);
}
/**
 * Delete a basket
 */

function deleteBasket(axios, params) {
  if (!params || !params.basketId) {
    return Promise.reject(new KpkApiError("params.basketId is null or undefined"));
  }

  return axios["delete"]("api/dam/baskets/" + params.basketId, params.axiosRequestConfig);
}
/**
 * Get share entry point basket
 */

function getShareBasket(axios, params) {
  if (!params || !params.basketId) {
    return Promise.reject(new KpkApiError("params.basketId is null or undefined"));
  }

  return axios.get("api/dam/baskets/" + params.basketId + "/share", params.axiosRequestConfig);
}
/**
 * Get public share basket information
 */

function getSharePublicBasket(axios, params) {
  if (!params || !params.basketId) {
    return Promise.reject(new KpkApiError("params.basketId is null or undefined"));
  }

  return axios.get("api/dam/baskets/" + params.basketId + "/share/public", params.axiosRequestConfig);
}
/**
 * Update a public share basket
 */

function putSharePublicBasket(axios, params) {
  if (!params || !params.basketId) {
    return Promise.reject(new KpkApiError("params.basketId is null or undefined"));
  }

  if (!params.status) {
    return Promise.reject(new KpkApiError("params.status is null or undefined"));
  }

  return axios.put("api/dam/baskets/" + params.basketId + "/share/public", {
    status: params.status,
    deactivationDate: params.deactivationDate,
    exportDefinition: params.exportDefinition,
    accessCode: params.accessCode,
    attachmentsVisible: params.attachmentsVisible
  }, params.axiosRequestConfig);
}

/**
 * Create a download request
 * Returns a 201
 */

function postDownloadRequests(axios, params) {
  if (!params.elementDownloads || params.elementDownloads.length === 0) {
    return Promise.reject(new KpkApiError("params.elementDownloads is null or undefined"));
  }

  var data = {
    elementDownloads: params.elementDownloads
  };
  return axios.post("/api/dam/download-requests", data, params.axiosRequestConfig);
}
/**
 * Get a download request
 * Returns an objet with download request informations
 */

function getDownloadRequests(axios, params) {
  if (!params.downloadRequestId) {
    return Promise.reject(new KpkApiError("params.downloadRequestId is null or undefined"));
  }

  return axios.get("/api/dam/download-requests/" + params.downloadRequestId, params.axiosRequestConfig);
}

function postDownloadValidationRequests(axios, params) {
  if (!params.reason) {
    return Promise.reject(new KpkApiError("params.reason is null or undefined"));
  }

  var data = {
    mediaIds: params.elementsId,
    responsibleIds: params.responsibleIds,
    reason: params.reason
  };
  return axios.post("/api/dam/download-validation-requests", data, params.axiosRequestConfig);
}
function postPublicDownloadValidationRequests(axios, params) {
  if (!params.reason) {
    return Promise.reject(new KpkApiError("params.reason is null or undefined"));
  }

  if (!params.mail) {
    return Promise.reject(new KpkApiError("params.mail is null or undefined"));
  }

  if (!params.lastName) {
    return Promise.reject(new KpkApiError("params.lastName is null or undefined"));
  }

  if (!params.firstName) {
    return Promise.reject(new KpkApiError("params.firstName is null or undefined"));
  }

  var data = {
    mediaIds: params.elementsId,
    responsibleIds: params.responsibleIds,
    reason: params.reason,
    lastName: params.lastName,
    firstName: params.firstName,
    mail: params.mail
  };
  return axios.post("/api/public/download-validation-requests", data, params.axiosRequestConfig);
}
function getDownloadValidationRequests(axios, params) {
  if (!params.downloadValidationRequestId) {
    return Promise.reject(new KpkApiError("params.downloadValidationRequestId is null or undefined"));
  }

  return axios.get("/api/dam/download-validation-requests/" + params.downloadValidationRequestId, params.axiosRequestConfig);
}

var _excluded$1 = ["axiosRequestConfig"];
/**
 * Create a stat hit
 */

function createHit(axios, params) {
  if (!params) {
    return Promise.reject(new KpkApiError("params is null or undefined"));
  }

  var axiosRequestConfig = params.axiosRequestConfig,
      rest = _objectWithoutPropertiesLoose(params, _excluded$1);

  return axios.post("api/stat/hits", _extends({}, rest), axiosRequestConfig);
}

/**
 * Get groups
 * Returns a paginated list of groups.
 */

function getGroups(axios, params) {
  return axios.get("/api/dam/groups", _extends({
    params: KpkApiBuildQueryParametersUtils.buildPagedQueryParameters(params)
  }, params.axiosRequestConfig));
}
/**
 * Get group by id
 * Returns a canonical representation of the group.
 */

function getGroup(axios, params) {
  if (!params || !params.groupId) {
    return Promise.reject(new KpkApiError("params.groupId is null or undefined"));
  }

  return axios.get("/api/dam/groups/" + encodeURIComponent(String(params.groupId)), params.axiosRequestConfig);
}
/**
 * Create a user in group
 */

function createUser(axios, params) {
  if (!params || !params.groupId || !params.user || !params.user.login || !params.user.email || !params.user.lastName || !params.user.firstName) {
    return Promise.reject(new KpkApiError("params.groupId or params.user is null or undefined or params.user.login is null or undefined or params.user.email is null or undefined or params.user.lastName is null or undefined or params.user.firstName is null or undefined"));
  }

  return axios.post("/api/dam/groups/" + encodeURIComponent(String(params.groupId)) + "/users", params.user, _extends({
    params: KpkApiBuildQueryParametersUtils.buildBooleanQueryParameter("notifyUpdate", params.notifyUpdate)
  }, params.axiosRequestConfig));
}

/**
 * Get public IAM configuration
 */
function getPublicIamConfiguration(axios, params) {
  return axios.get("/api/public/iam-configuration", params == null ? void 0 : params.axiosRequestConfig);
}

/**
 * Get properties
 * Returns a paginated list of properties.
 */

function getProperties(axios, params) {
  return axios.get("/api/dam/properties", _extends({
    params: KpkApiBuildQueryParametersUtils.buildPagedQueryParameters(params)
  }, params.axiosRequestConfig));
}
/**
 * Get property by id
 * Returns a canonical representation of the property.
 */

function getProperty(axios, params) {
  if (!params || !params.propertyId) {
    return Promise.reject(new KpkApiError("params.propertyId is null or undefined"));
  }

  return axios.get("/api/dam/properties/" + encodeURIComponent(params.propertyId), params.axiosRequestConfig);
}

/**
 * Get user interfaces
 */

/**
 * Get current ui
 */
var getCurrentUi = function getCurrentUi(axios, params) {
  try {
    return Promise.resolve(getDam(axios, params)).then(function (_getDam) {
      var kpkApiDam = _getDam.data;

      if (kpkApiDam) {
        if (kpkApiDam && kpkApiDam._links && kpkApiDam._links["kpk:current-ui"]) {
          var uIIdStr = KpkApiResponseUtils.extractEntityIdFromHref(kpkApiDam._links["kpk:current-ui"].href);

          if (uIIdStr) {
            return getUi(axios, _extends({
              uiId: +uIIdStr
            }, params));
          }
        }
      }

      return Promise.reject(new KpkApiError("Cannot get current user"));
    });
  } catch (e) {
    return Promise.reject(e);
  }
};
/**
 * Get user interface by clientId
 */

function getUis(axios, params) {
  return axios.get("/api/dam/user-interfaces", _extends({
    params: KpkApiBuildQueryParametersUtils.buildPagedQueryParameters(params)
  }, params.axiosRequestConfig));
}
/**
 * Get user interface
 */

function getUi(axios, params) {
  if (!params || params.uiId === undefined) {
    return Promise.reject(new KpkApiError("params.uiId is null or undefined"));
  }

  return axios.get("/api/dam/user-interfaces/" + params.uiId, _extends({
    params: KpkApiBuildQueryParametersUtils.buildQueryParameters(params)
  }, params.axiosRequestConfig));
}
/**
 * Update ui
 */

function updateUi(axios, params) {
  if (!params || !params.uiId) {
    return Promise.reject(new KpkApiError("params or params.uiId is null or undefined"));
  }

  return axios.put("/api/dam/user-interfaces/" + encodeURIComponent(String(params.uiId)), {
    gdprUpdateDate: params.gdprUpdateDate,
    gdprCurrentResources: params.gdprCurrentResources
  }, params.axiosRequestConfig);
}
function getUiByClientId(axios, params) {
  if (!params || params.clientId === undefined) {
    return Promise.reject(new KpkApiError("params.clientId is null or undefined"));
  }

  return axios.get("/api/dam/user-interfaces/by-clientId/" + params.clientId, _extends({
    params: KpkApiBuildQueryParametersUtils.buildQueryParameters(params)
  }, params.axiosRequestConfig));
}

/**
 * GET Media Links.
 * media-links.
 * This relations targets the list of media link types of current media.
 */

function getMediaLinks(axios, params) {
  return axios.get("api/dam/medias/" + params.mediaId + "/media-links/", _extends({
    params: KpkApiBuildQueryParametersUtils.buildPagedQueryParameters(params)
  }, params.axiosRequestConfig));
}
/**
 * GET Media Link Medias.
 * Medias list of current media by type.
 * This list can be sorted by fields and we can selected fields to display.
 */

function getMediaLinkMedias(axios, params) {
  return axios.get("api/dam/medias/" + params.mediaId + "/media-links/" + params.mediaLinkId + "/medias", _extends({
    params: KpkApiBuildQueryParametersUtils.buildSearchQueryParameters(params)
  }, params.axiosRequestConfig));
}

function getResourceFiles(axios) {
  return axios.get("/api/dam/file-resources");
}
function getResourceFilesByType(axios, params) {
  if (!params.type) {
    return Promise.reject(new KpkApiError("params.type is null or undefined"));
  }

  return axios.get("/api/dam/file-resources/" + params.type, _extends({
    params: KpkApiBuildQueryParametersUtils.buildSearchQueryParameters(params)
  }, params.axiosRequestConfig));
}
function getResourceFile(axios, params) {
  if (!params.path) {
    return Promise.reject(new KpkApiError("params.path is null or undefined"));
  }

  if (!params.type) {
    return Promise.reject(new KpkApiError("params.type is null or undefined"));
  }

  if (!params.fileName) {
    return Promise.reject(new KpkApiError("params.fileName is null or undefined"));
  }

  return axios.get("/api/dam/file-resources/" + params.type + "/" + params.path + "?versionFileName=" + params.fileName, params.axiosRequestConfig);
}
function checkResourceFileExistence(axios, params) {
  if (!params.path) {
    return Promise.reject(new KpkApiError("params.path is null or undefined"));
  }

  if (!params.type) {
    return Promise.reject(new KpkApiError("params.type is null or undefined"));
  }

  if (!params.fileName) {
    return Promise.reject(new KpkApiError("params.fileName is null or undefined"));
  }

  return axios.head("/api/dam/file-resources/" + params.type + "/" + params.path + "?versionFileName=" + params.fileName, params.axiosRequestConfig);
}
function createResourceFile(axios, params) {
  if (!params.path) {
    return Promise.reject(new KpkApiError("params.path is null or undefined"));
  }

  if (!params.file) {
    return Promise.reject(new KpkApiError("params.file is null or undefined"));
  }

  if (!params.type) {
    return Promise.reject(new KpkApiError("params.type is null or undefined"));
  }

  return axios.post("/api/dam/file-resources/" + params.type + "/" + params.path, params.file, params.axiosRequestConfig);
}
function replaceResourceFile(axios, params) {
  if (!params.path) {
    return Promise.reject(new KpkApiError("params.path is null or undefined"));
  }

  if (!params.file) {
    return Promise.reject(new KpkApiError("params.file is null or undefined"));
  }

  return axios.put("/api/dam/file-resources/" + params.type + "/" + params.path + "?version=true", params.file, params.axiosRequestConfig);
}
function deleteResourceFile(axios, params) {
  if (!params.path) {
    return Promise.reject(new KpkApiError("params.path is null or undefined"));
  }

  return axios["delete"]("/api/dam/file-resources/" + params.type + "/" + params.path + "?fileNameVersion=" + params.fileName, params.axiosRequestConfig);
}

function getShareTemplates(axios, params) {
  return axios.get("/api/dam/share/templates", _extends({
    params: KpkApiBuildQueryParametersUtils.buildSearchQueryParameters(params)
  }, params.axiosRequestConfig));
}
function getShareTemplateDomains(axios, params) {
  if (!params || !params.templateId) {
    return Promise.reject(new KpkApiError("params.templateId is null or undefined"));
  }

  return axios.get("/api/dam/share/templates/" + params.templateId + "/domains", _extends({
    params: KpkApiBuildQueryParametersUtils.buildSearchQueryParameters(params)
  }, params.axiosRequestConfig));
}

function getContactSheets(axios) {
  return axios.get("/api/dam/contact-sheets");
}

/**
 * Get public share information.
 *
 * @param params contains tokenId
 */

function getPublicShare(axios, params) {
  if (!params || !params.tokenId) {
    return Promise.reject(new KpkApiError("params.tokenId is null or undefined"));
  }

  return axios.get("api/share/" + params.tokenId, _extends({
    params: KpkApiBuildQueryParametersUtils.buildQueryParameters(params)
  }, params.axiosRequestConfig));
}
/**
 * Get public shared media.
 *
 * @param params contains tokenId and sharedMediaId
 */

function getPublicSharedMedia(axios, params) {
  if (!params || !params.tokenId || !params.sharedMediaId) {
    return Promise.reject(new KpkApiError("params.tokenId or params.sharedMediaId is null or undefined"));
  }

  return axios.get("api/share/" + params.tokenId + "/shared-medias/" + params.sharedMediaId, _extends({
    params: KpkApiBuildQueryParametersUtils.buildQueryParameters(params)
  }, params.axiosRequestConfig));
}
/**
 * Get public shared media player.
 *
 * @param params contains tokenId and sharedMediaId
 */

function getPublicSharedMediaPlayer(axios, params) {
  if (!params || !params.tokenId || !params.sharedMediaId) {
    return Promise.reject(new KpkApiError("params.tokenId or params.sharedMediaId is null or undefined"));
  }

  return axios.get("api/share/" + params.tokenId + "/shared-medias/" + params.sharedMediaId + "/player", _extends({
    params: KpkApiBuildQueryParametersUtils.buildQueryParameters(params)
  }, params.axiosRequestConfig));
}
/**
 * Get public shared media embed for rich medias.
 *
 * @param axios axios instance
 * @param params contains tokenId and sharedMediaId
 */

function getPublicSharedMediaEmbed(axios, params) {
  if (!params || !params.tokenId || !params.sharedMediaId) {
    return Promise.reject(new KpkApiError("params.tokenId or params.sharedMediaId is null or undefined"));
  }

  return axios.get("api/share/" + params.tokenId + "/shared-medias/" + params.sharedMediaId + "/embed", _extends({
    params: KpkApiBuildQueryParametersUtils.buildQueryParameters(params)
  }, params.axiosRequestConfig));
}
/**
 * Get public shared basket.
 *
 * @param params contains tokenId
 */

function getPublicSharedBasket(axios, params) {
  if (!params || !params.tokenId) {
    return Promise.reject(new KpkApiError("params.tokenId is null or undefined"));
  }

  return axios.get("api/share/" + params.tokenId + "/shared-basket", _extends({
    params: KpkApiBuildQueryParametersUtils.buildQueryParameters(params)
  }, params.axiosRequestConfig));
}
/**
 * Get public shared basket medias.
 *
 * @param params contains tokenId
 */

function getPublicSharedBasketMedias(axios, params) {
  if (!params || !params.tokenId) {
    return Promise.reject(new KpkApiError("params.tokenId is null or undefined"));
  }

  return axios.get("api/share/" + params.tokenId + "/shared-basket/medias", _extends({
    params: KpkApiBuildQueryParametersUtils.buildQueryParameters(params)
  }, params.axiosRequestConfig));
}
/**
 * Create an advanced shared search resource.
 *
 * @param params contains tokenId, headers and filter information
 */

function createPublicShareAdvancedSearch(axios, params) {
  if (!params || !params.tokenId || !params.filter) {
    return Promise.reject(new KpkApiError("params.tokenId or params.filter is null or undefined"));
  }

  return axios.post("api/share/" + params.tokenId + "/shared-search/advanced", {
    _embedded: {
      filter: params.filter
    }
  }, params.axiosRequestConfig);
}
/**
 * Get shared advanced search filtered media resource list.
 *
 * @param params contains tokenId, headers informations and technical identifier of the advanced search
 */

function getPublicShareAdvancedSearch(axios, params) {
  if (!params || !params.tokenId || !params.advancedSearchId) {
    return Promise.reject(new KpkApiError("params.tokenId or params.advancedSearchId is null or undefined"));
  }

  return axios.get("api/share/" + params.tokenId + "/shared-search/advanced/" + encodeURIComponent(params.advancedSearchId) + "/media", _extends({
    params: KpkApiBuildQueryParametersUtils.buildSearchQueryParameters(params)
  }, params.axiosRequestConfig));
}
/**
 * Get public share form.
 *
 * @param params contains tokenId and formId
 */

function getPublicShareForm(axios, params) {
  if (!params || !params.tokenId || !params.formId) {
    return Promise.reject(new KpkApiError("params.tokenId or params.formId is null or undefined"));
  }

  return axios.get("/api/share/" + params.tokenId + "/forms/" + encodeURIComponent(String(params.formId)), _extends({
    params: KpkApiBuildQueryParametersUtils.buildQueryParameters(params)
  }, params.axiosRequestConfig));
}
/**
 * Get public share forms.
 *
 * @param params contains tokenId
 */

function getPublicShareForms(axios, params) {
  if (!params || !params.tokenId) {
    return Promise.reject(new KpkApiError("params.tokenId is null or undefined"));
  }

  return axios.get("/api/share/" + params.tokenId + "/forms", _extends({
    params: KpkApiBuildQueryParametersUtils.buildPagedQueryParameters(params)
  }, params.axiosRequestConfig));
}
/**
 * Get public share form field.
 *
 * @param params contains tokenId, formId and fieldId
 */

function getPublicShareFormField(axios, params) {
  if (!params || !params.tokenId || !params.formId || !params.fieldId) {
    return Promise.reject(new KpkApiError("params.tokenId or params.formId or params.fieldId is null or undefined"));
  }

  return axios.get("/api/share/" + params.tokenId + "/forms/" + encodeURIComponent(String(params.formId)) + "/fields/" + encodeURIComponent(String(params.fieldId)), _extends({
    params: KpkApiBuildQueryParametersUtils.buildQueryParameters(params)
  }, params.axiosRequestConfig));
}
/**
 * Get public share form fields.
 *
 * @param params contains tokenId and formId
 */

function getPublicShareFormFields(axios, params) {
  if (!params || !params.tokenId || !params.formId) {
    return Promise.reject(new KpkApiError("params.tokenId or params.formId is null or undefined"));
  }

  return axios.get("/api/share/" + params.tokenId + "/forms/" + encodeURIComponent(String(params.formId)) + "/fields", _extends({
    params: KpkApiBuildQueryParametersUtils.buildQueryParameters(params)
  }, params.axiosRequestConfig));
}
/**
 * Get public share sheet field.
 *
 * @param params contains tokenId and sheetFieldId
 */

function getPublicShareSheetField(axios, params) {
  if (!params || !params.tokenId || !params.sheetFieldId) {
    return Promise.reject(new KpkApiError("params.tokenId or params.sheetFieldId is null or undefined"));
  }

  return axios.get("/api/share/" + params.tokenId + "/sheet-fields/" + encodeURIComponent(String(params.sheetFieldId)), _extends({
    params: KpkApiBuildQueryParametersUtils.buildQueryParameters(params)
  }, params.axiosRequestConfig));
}
/**
 * Get public share sheet fields.
 *
 * @param params contains tokenId
 */

function getPublicShareSheetFields(axios, params) {
  if (!params || !params.tokenId) {
    return Promise.reject(new KpkApiError("params.tokenId is null or undefined"));
  }

  return axios.get("/api/share/" + params.tokenId + "/sheet-fields", _extends({
    params: KpkApiBuildQueryParametersUtils.buildPagedQueryParameters(params)
  }, params.axiosRequestConfig));
}
/**
 * Create a public share selection.
 */

function postPublicShareSelection(axios, params) {
  if (!params || !params.tokenId) {
    return Promise.reject(new KpkApiError("params.tokenId is null or undefined"));
  }

  return axios.post("/api/share/" + params.tokenId + "/shared-selections", null, params.axiosRequestConfig);
}
/**
 * Delete a public share selection.
 */

function deletePublicShareSelection(axios, params) {
  if (!params || !params.tokenId || !params.selectionId) {
    return Promise.reject(new KpkApiError("params.tokenId or params.selectionId is null or undefined"));
  }

  return axios["delete"]("/api/share/" + params.tokenId + "/shared-selections/" + encodeURIComponent(String(params.selectionId)), params.axiosRequestConfig);
}
/**
 * Get public share selection by id.
 */

function getPublicShareSelection(axios, params) {
  if (!params || !params.tokenId || !params.selectionId) {
    return Promise.reject(new KpkApiError("params.tokenId or params.selectionId is null or undefined"));
  }

  return axios.get("/api/share/" + params.tokenId + "/shared-selections/" + encodeURIComponent(String(params.selectionId)), _extends({
    params: KpkApiBuildQueryParametersUtils.buildQueryParameters(params)
  }, params.axiosRequestConfig));
}
/**
 * Get public share selection medias.
 */

function getPublicShareSelectionMedias(axios, params) {
  if (!params || !params.tokenId || !params.selectionId) {
    return Promise.reject(new KpkApiError("params.tokenId or params.selectionId is null or undefined"));
  }

  return axios.get("/api/share/" + params.tokenId + "/shared-selections/" + encodeURIComponent(String(params.selectionId)) + "/medias", _extends({
    params: KpkApiBuildQueryParametersUtils.buildSearchQueryParameters(params)
  }, params.axiosRequestConfig));
}
/**
 * Get public share selection available export formats for selected medias.
 */

function getPublicShareSelectionAvailableExportFormats(axios, params) {
  if (!params || !params.tokenId || !params.selectionId) {
    return Promise.reject(new KpkApiError("params.tokenId or params.selectionId is null or undefined"));
  }

  var queryParams = KpkApiBuildQueryParametersUtils.buildQueryParameters(params);

  if (params.groupBy) {
    queryParams.set("groupBy", params.groupBy);
  }

  return axios.get("/api/share/" + params.tokenId + "/shared-selections/" + encodeURIComponent(String(params.selectionId)) + "/available-export-formats", _extends({
    params: queryParams
  }, params.axiosRequestConfig));
}
/**
 * Get public share selection terms of use for selected medias.
 */

function getPublicShareSelectionMediasTermsOfUse(axios, params) {
  if (!params || !params.tokenId || !params.selectionId) {
    return Promise.reject(new KpkApiError("params.tokenId or params.selectionId is null or undefined"));
  }

  return axios.get("/api/share/" + params.tokenId + "/shared-selections/" + encodeURIComponent(String(params.selectionId)) + "/terms-of-use", _extends({
    params: KpkApiBuildQueryParametersUtils.buildSearchQueryParameters(params)
  }, params.axiosRequestConfig));
}
/**
 * Post public share medias collections by ids into a public share selection.
 */

function postPublicShareSelectionMediasCollection(axios, params) {
  if (!params || !params.tokenId || !params.selectionId || !params.mediaIds) {
    return Promise.reject(new KpkApiError("params.tokenId, params.selectionId or params.mediaIds is null or undefined"));
  }

  var queryParams = KpkApiBuildQueryParametersUtils.buildQueryParameters(params);

  if (params.asAdmin) {
    queryParams.set("as-admin", "" + params.asAdmin);
  }

  return axios.post("/api/share/" + params.tokenId + "/shared-selections/" + encodeURIComponent(String(params.selectionId)) + "/medias-collection", {
    ids: params.mediaIds
  }, _extends({
    params: queryParams
  }, params.axiosRequestConfig));
}
/**
 * Delete public share medias collections by ids of a public share selection.
 */

function deletePublicShareSelectionMediasCollection(axios, params) {
  if (!params || !params.tokenId || !params.selectionId || !params.mediaIds) {
    return Promise.reject(new KpkApiError("params.tokenId, params.selectionId or params.mediaIds is null or undefined"));
  }

  var queryParams = KpkApiBuildQueryParametersUtils.buildQueryParameters(params);

  if (params.asAdmin) {
    queryParams.set("as-admin", "" + params.asAdmin);
  } // Use axios function because the shorthand "delete" function does not accept body/data


  return axios(_extends({
    method: "DELETE",
    url: "/api/share/" + params.tokenId + "/shared-selections/" + encodeURIComponent(String(params.selectionId)) + "/medias-collection",
    data: {
      ids: params.mediaIds
    },
    params: queryParams
  }, params.axiosRequestConfig));
}
/**
 * Create a public share download request.
 */

function postPublicShareDownloadRequests(axios, params) {
  if (!params || !params.tokenId || !params.elementDownloads || params.elementDownloads.length === 0) {
    return Promise.reject(new KpkApiError("params.tokenId or params.elementDownloads is null or undefined"));
  }

  var data = {
    elementDownloads: params.elementDownloads
  };
  return axios.post("/api/share/" + params.tokenId + "/download-requests", data, params.axiosRequestConfig);
}
/**
 * Get a public share download request.
 */

function getPublicShareDownloadRequests(axios, params) {
  if (!params || !params.tokenId || !params.downloadRequestId) {
    return Promise.reject(new KpkApiError("params.tokenId or params.downloadRequestId is null or undefined"));
  }

  return axios.get("/api/share/" + params.tokenId + "/download-requests/" + params.downloadRequestId, _extends({
    params: KpkApiBuildQueryParametersUtils.buildQueryParameters(params)
  }, params.axiosRequestConfig));
}
/**
 * Get public share media attachments.
 */

function getPublicShareMediaAttachments(axios, params) {
  if (!params || !params.tokenId || !params.mediaId) {
    return Promise.reject(new KpkApiError("params.mediaId is null or undefined"));
  }

  return axios.get("/api/share/" + params.tokenId + "/shared-medias/" + params.mediaId + "/attachments", _extends({
    params: KpkApiBuildQueryParametersUtils.buildPagedQueryParameters(params)
  }, params.axiosRequestConfig));
}
/**
 * Get public share media attachment.
 */

function getPublicShareMediaAttachment(axios, params) {
  if (!params || !params.tokenId || !params.mediaId || !params.attachmentId) {
    return Promise.reject(new KpkApiError("params.tokenId, params.mediaId or params.attachmentId is null or undefined"));
  }

  return axios.get("/api/share/" + params.tokenId + "/shared-medias/" + params.mediaId + "/attachments/" + params.attachmentId, _extends({
    params: KpkApiBuildQueryParametersUtils.buildQueryParameters(params)
  }, params.axiosRequestConfig));
}
/**
 * Create public share media attachment uri.
 */

function createPublicShareMediaAttachmentUri(axios, params) {
  if (!params || !params.tokenId || !params.mediaId || !params.attachmentId) {
    return Promise.reject(new KpkApiError("params.tokenId, params.mediaId or params.attachmentId is null or undefined"));
  }

  return axios.post("/api/share/" + params.tokenId + "/shared-medias/" + params.mediaId + "/attachments/" + params.attachmentId + "/download-link?linkType=kpk", null, _extends({
    params: KpkApiBuildQueryParametersUtils.buildQueryParameters(params)
  }, params.axiosRequestConfig));
}

/**
 * Get public property by id
 * Returns a canonical representation of the property.
 */

function getPublicProperty(axios, params) {
  if (!params || !params.propertyId) {
    return Promise.reject(new KpkApiError("params.propertyId is null or undefined"));
  }

  return axios.get("/api/public/properties/" + encodeURIComponent(params.propertyId), params.axiosRequestConfig);
}

function postClassificationValidationRequest(axios, params) {
  if (!params.mediaIds) {
    return Promise.reject(new KpkApiError("params.mediaIds is null or undefined"));
  }

  return axios.post("/api/dam/classification-validation-requests", {
    mediaIds: params.mediaIds,
    responsibleIds: params.responsibleIds,
    reason: params.reason
  }, params.axiosRequestConfig);
}

function postFile(axios, params) {
  return axios.post("/api/dam/files", params.data ? params.data : null, params.axiosRequestConfig);
}
function putFile(axios, params) {
  if (!params || !params.fileId || !params.data) {
    return Promise.reject(new KpkApiError("params.fileId OR params.data is null or undefined"));
  }

  return axios.put("/api/dam/files/" + params.fileId, params.data, params.axiosRequestConfig);
}
function getFile(axios, params) {
  if (!params || !params.fileId) {
    return Promise.reject(new KpkApiError("params.fileId is null or undefined"));
  }

  return axios.get("/api/dam/files/" + params.fileId, params.axiosRequestConfig);
}

/**
 * Get thesaurus tree
 * Returns a list of child thesaurus
 */

function getThesaurusTree(axios, params) {
  return axios.get(params.thesaurusTreeId ? "/api/dam/thesaurus-tree/" + params.thesaurusTreeId : "/api/dam/thesaurus-tree", _extends({
    params: KpkApiBuildQueryParametersUtils.buildSearchQueryParameters(params)
  }, params.axiosRequestConfig));
}

/**
 * Get thesaurus
 * Returns a thesaurus
 */

function getThesaurus(axios, params) {
  return axios.get("/api/dam/thesauruses/" + params.thesaurusId, _extends({
    params: KpkApiBuildQueryParametersUtils.buildSearchQueryParameters(params)
  }, params.axiosRequestConfig));
}

var _excluded = ["axiosRequestConfig", "serviceId"];
/**
 * Get signed links
 */

function getSignedLinks(axios, params) {
  if (!params) {
    return Promise.reject(new KpkApiError("params is null or undefined"));
  }

  var axiosRequestConfig = params.axiosRequestConfig,
      serviceId = params.serviceId,
      rest = _objectWithoutPropertiesLoose(params, _excluded);

  return axios.post("api/dam/services/" + serviceId + "/signatures", _extends({}, rest), axiosRequestConfig);
}

/**
 * Get media permalinks
 */

function getMediaPermalinks(axios, params) {
  if (!params || !params.mediaId) {
    return Promise.reject(new KpkApiError("params.mediaId is null or undefined"));
  }

  return axios.get("api/dam/medias/" + params.mediaId + "/permalinks/", _extends({
    params: KpkApiBuildQueryParametersUtils.buildPagedQueryParameters(params)
  }, params.axiosRequestConfig));
}

/**
 * Get api
 * Returns a canonical representation of /api
 */
function getApi(axios, params) {
  return axios.get("/api", params == null ? void 0 : params.axiosRequestConfig);
}

/**
 * Get all labels
 */

function getLabels(axios, params) {
  return axios.get("/api/dam/medias/labels", _extends({
    params: KpkApiBuildQueryParametersUtils.buildPagedQueryParameters(params)
  }, params.axiosRequestConfig));
}

export { Definition, DownloadRequestStatus, KpkApiAdditionalAttributeType, KpkApiAdvancedSearchCriteriaAvailableModifier, KpkApiAdvancedSearchCriteriaFieldType, KpkApiAdvancedSearchCriteriaType, KpkApiAdvancedSearchFilterFieldType, KpkApiAdvancedSearchFilterModifier, KpkApiAdvancedSearchFilterType, KpkApiAdvancedSearchType, KpkApiAssignedGroupStatus, KpkApiAttachmentCloudProviderState, KpkApiAttachmentType, KpkApiBasketPermission, KpkApiBasketStatus, KpkApiBasketType, KpkApiBuildQueryParametersUtils, KpkApiClassificationValidationRequestStatus, KpkApiError, KpkApiFacetType, KpkApiFieldPermission, KpkApiFolderNodePermission, KpkApiFormFieldType, KpkApiFormType, KpkApiHitConnectionMode, KpkApiHitContributionSpaceType, KpkApiHitHitType, KpkApiHitSearchType, KpkApiMediaAnnotation, KpkApiMediaColorSpace, KpkApiMediaDownloadLevel, KpkApiMediaDuplicateMediaStatus, KpkApiMediaOrientation, KpkApiMediaPermission, KpkApiMediaStatus, KpkApiMediaThumbnailGenerationStatus, KpkApiOrientationContactSheet, KpkApiProfileAuthorization, KpkApiPublicShareExportDefinition, KpkApiPublicShareStatus, KpkApiPublicShareTokenExportDefinition, KpkApiResponseUtils, KpkApiScriptRunStatus, KpkApiScriptType, KpkApiSearchFolderSort, KpkApiSelectionAvailableExportGroupBy, KpkApiShareTokenExportDefinition, KpkApiSheetFieldType, KpkApiThumbnailTemplateFormat, KpkApiThumbnailTemplatePermission, KpkApiUiType, KpkApiUserPermission, KpkApiVideoConfigurationThemeValue, KpkApiVideoConfigurationTrackKind, Type, addMediaToBasket, addMediaToFolder, addMediasToBasket, assignGroupToUser, autocomplete, checkResourceFileExistence, createAdvancedSearch, createBasket, createHit, createMediaAttachmentDownloadLink, createMediaAttachmentUri, createMediaShareToken, createPublicShareAdvancedSearch, createPublicShareMediaAttachmentUri, createResourceFile, createScriptRun, createUser, createUserAdditionalAttribute, createUserThumbnailTemplate, deleteBasket, deleteMediaShareToken, deletePublicShareSelection, deletePublicShareSelectionMediasCollection, deleteResourceFile, deleteUserAssignedGroup, deleteUserSelection, deleteUserSelectionMediasCollection, deleteUserThumbnailTemplate, getAdvancedSearch, getAdvancedSearchCriteria, getAdvancedSearchCriterias, getApi, getBasket, getBasketMedias, getBaskets, getContactSheets, getCurrentUi, getCurrentUser, getDam, getDownloadRequests, getDownloadValidationRequests, getFile, getFolder, getFolderTree, getFolderTreeNode, getFolders, getForm, getFormField, getFormFields, getForms, getGroup, getGroups, getLabels, getLookup, getLookups, getMedia, getMediaAttachment, getMediaAttachments, getMediaEmbed, getMediaFolders, getMediaLinkMedias, getMediaLinks, getMediaPermalinks, getMediaPlayer, getMediaSharePublic, getMediaShareTokens, getProperties, getProperty, getPublicIamConfiguration, getPublicProperty, getPublicShare, getPublicShareAdvancedSearch, getPublicShareDownloadRequests, getPublicShareForm, getPublicShareFormField, getPublicShareFormFields, getPublicShareForms, getPublicShareMediaAttachment, getPublicShareMediaAttachments, getPublicShareSelection, getPublicShareSelectionAvailableExportFormats, getPublicShareSelectionMedias, getPublicShareSelectionMediasTermsOfUse, getPublicShareSheetField, getPublicShareSheetFields, getPublicSharedBasket, getPublicSharedBasketMedias, getPublicSharedMedia, getPublicSharedMediaEmbed, getPublicSharedMediaPlayer, getResourceFile, getResourceFiles, getResourceFilesByType, getScriptRuns, getScripts, getSearchFolders, getShareBasket, getSharePublicBasket, getShareTemplateDomains, getShareTemplates, getSheetField, getSheetFields, getSignedLinks, getThesaurus, getThesaurusTree, getUi, getUiByClientId, getUis, getUser, getUserAssignedGroup, getUserAssignedGroups, getUserAuthorizedInterfaces, getUserAvailableGroups, getUserSelection, getUserSelectionAvailableExportFormats, getUserSelectionBulkFields, getUserSelectionMedias, getUserSelectionMediasTermsOfUse, getUserSelections, getUserThumbnailTemplates, postClassificationValidationRequest, postDownloadRequests, postDownloadValidationRequests, postFile, postMedia, postPublicDownloadValidationRequests, postPublicShareDownloadRequests, postPublicShareSelection, postPublicShareSelectionMediasCollection, postUserSelection, postUserSelectionBulk, postUserSelectionMediasCollection, putFile, putSharePublicBasket, removeAllMediasFromBasket, removeMediaFromBasket, replaceResourceFile, searchBaskets, searchMedias, searchUsers, updateBasket, updateMedia, updateMediaSharePublic, updateMediaShareToken, updateUi, updateUser, updateUserAdditionalAttribute, updateUserAssignedGroup, updateUserThumbnailTemplate };
//# sourceMappingURL=index.m.js.map
